window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _loadSubSections: function() {
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      for (var e = selectedValues, s = variants, found = _.find(s, function(variant) {
        return e.every(function(values) {
          return _.isEqual(variant[values.index], values.value)
        })
      }), r = 0; r < e.length; r++) {
      var t = r + 1;
      $(".js-swatch-display--" + t).text(e[r].value)
    }
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
      
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
      //theme.updateCurrencies();
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }
    
    theme.miniCart.generateCart(cart);
    //theme.updateCurrencies();
    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var styleCart = $('.js-mini-cart').attr("data-cartmini");
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
    
    this.showNotice = false;
    if (this.$form.length) {
      this.showNotice  = this.$form.hasClass('js-form--notice')? true : false;
    }
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    evt.preventDefault();
    var $form = this.$form;
    var $submitButton = $form.find('button[type="submit"]');
    $submitButton.addClass('is-loading');

    // Optimistic: bump cart count badge instantly
    var $countEls = $('.js-cart-count');
    var currentCount = parseInt($countEls.first().text(), 10) || 0;
    var addQty = parseInt($form.find('[name="quantity"]').val(), 10) || 1;
    $countEls.removeClass('is-empty').text(currentCount + addQty);

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        // Revert optimistic count on error
        $countEls.text(currentCount > 0 ? currentCount : '').toggleClass('is-empty', currentCount <= 0);
        this.error(XMLHttpRequest, textStatus);
      }, this),
      complete: function() {
        $submitButton.removeClass('is-loading');
      }
    };
    $.ajax(params);
  };
  
  cart.prototype.success = function(item) {
    theme.miniCart.refresh();
    if(styleCart != 'true' ){
      if (this.showNotice) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
      }else{
        theme.crosssell.showPopup(item);
      }
    }
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    
    if (data.message) {
      theme.alert.new('',data.description,3000,'warning');
    }
  };

  return cart;
})();

/*================ TEMPLATES ================*/
theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    // check if reset password form was successfully submited
    if (!$('.reset-password-success').length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function HeaderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var stickyId = $container.attr('data-sticky');
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'left');
    this.selectors = {
      headerID : '.section-' + sectionId,
      typeHeader : stickyId ,
    }
    this.init();
    
  }
  HeaderSection.prototype = _.assignIn({}, HeaderSection.prototype, {
    init: function() {
      this.stickyHeader();
      this.headerSearch();
      this.headerHeight();
      this.delayMenu();
    },
    headerHeight : function(){
      var header = document.querySelector('.site-header');
      var rootElement = document.querySelector(':root');
      rootElement.style.setProperty("--height-header", header.offsetHeight + "px");
    },
    headerSearch: function(){
      let modalOpen =  document.querySelector(".modal__toggle-open"),
          close = document.querySelector(".search-modal__close-button"),
          searchMobile = document.querySelector(".modal__toggle-search-mobile");
          input = document.getElementById("Search-In-Modal"),
          overlayOpen  = document.querySelector(".modal-overlay");

      modalOpen.addEventListener("click", toggleClassSearch);
      overlayOpen.addEventListener("click", toggleClassSearch);
      close.addEventListener("click", toggleClassSearch);
      searchMobile.addEventListener("click", toggleClassSearch);
     
      function toggleClassSearch(){
        document.querySelector(".detail-modal").classList.toggle("active");
        overlayOpen.classList.toggle("active");
        if (window.matchMedia('(min-width: 992px)').matches) {
          input.focus();
        }
      }
      overlayOpen.addEventListener('click', function(){
        input.value = '';
        document.querySelector('.predictive-search').style.display = 'none';
      });
      close.addEventListener('click', function(){
        input.value = '';
        document.querySelector('.predictive-search').style.display = 'none';
      });
    },
    // Stickyheader
    stickyHeader: function() {
      var stickHeaderClass = this.selectors.headerID;
      var stickyHeader =  this.selectors.typeHeader;

      var prevScrollpos = window.pageYOffset;
      if( stickyHeader === 'sticky' ){
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > 30) {
            document.querySelector(stickHeaderClass).classList.add("active");
          } else {
            document.querySelector(stickHeaderClass).classList.remove("active");
          }
          prevScrollpos = currentScrollPos;
        }
      }
      else if (stickyHeader === 'sticky-top' ){ 
        // Apply hide-on-scroll behavior on all breakpoints (mobile + desktop)
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          var headerEl = document.querySelector(stickHeaderClass);
          if(!headerEl) return;
          var offsetHeight = headerEl.clientHeight;
          if (prevScrollpos > currentScrollPos && prevScrollpos - currentScrollPos > offsetHeight) {
            headerEl.style.top = "0";
            if(currentScrollPos == 0){
              headerEl.classList.remove("active");
            }
            else{
              headerEl.classList.add("active");
            }
            
          } else if (currentScrollPos - prevScrollpos > offsetHeight) {
            headerEl.style.top = `-${offsetHeight}px`;
            headerEl.classList.remove("active");
          }
          prevScrollpos = currentScrollPos;
        }
        // Reset top on resize/orientation change
        window.addEventListener('resize', function(){
          var headerEl = document.querySelector(stickHeaderClass);
          if(headerEl) headerEl.style.top = "0";
        });
      }
      else{
        return null;
      }
    },
    // hoverMenu
    delayMenu: function(){
      var megaMenu = $('.site-nav__item-mega');  
      megaMenu.each(function( index ) {
        var childLink = $(this).find('.d-col-link');
        childLink.each(function( i ) {
          $(this).css("animation-delay", `${(i+1)/10 * 0.8}s`);
        });
      });
    }
  });

  return HeaderSection;
})();

theme.CartDraw = (function() {
  theme.testDrawer = new theme.Drawers('testDrawer', 'left');
  /*$('.drawer-crossell-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    dots: false,
    arrows:true,
    infinite:false,
  });*/
  /*$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree_checkout').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });*/
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750,
    mediaEffect: 'fade',
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var sectionTem = $container.attr('data-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.js-variant-sku',
      productImageMain: '.gallery-wrap'+ sectionId,
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      availability: '.product-single__availability',
      hurrify : '.js-hurrify',
      txtHurrify : '.js-hurrify .js-txt-hurrify',
      labelwrap_sale: '.product-tag-sale',
      numbersale_change : '.product-tag-sale-number'

    };
    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      sectionTem:sectionTem,
      template: $container.data('template') || '',
      mediaEffect: $container.data('media-effect') || defaults.mediaEffect,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._productZoomImage();
      if (this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2') {
        this._bindCollageThumbLightbox();
      } else {
        this._productThumbSwitch();
      }
      this._productThumbnailSlider();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);
      var variant = this.variants
      if( variant.currentVariant.compare_at_price > variant.currentVariant.price){
        var load_sale_minus = variant.currentVariant.compare_at_price - variant.currentVariant.price;
        var load_sale_per = load_sale_minus*100 / variant.currentVariant.compare_at_price;
        var load_roundNumber = parseInt(load_sale_per);
        $(this.selectors.numbersale_change).text(`${load_roundNumber}%`);
        $(this.selectors.labelwrap_sale).removeClass('hide');
      }else{
        $(this.selectors.labelwrap_sale).addClass('hide');
      }
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateStickyCart.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateSwatchTitle.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock),
          $hurrify = $(this.selectors.hurrify),
          $txtHurrify  = $(this.selectors.txtHurrify);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        $hurrify.removeClass('hide').find('.progress-bar').css('width',variant.inventory_quantity*10+'%');
        $txtHurrify.html(
          theme.strings.stringHurrify.replace(
            'number',
            variant.inventory_quantity
          )
        );
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
      $hurrify.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;


      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
       
        let optionName = this.productSingleObject.options;
        
        // Select a valid variant if available
        //theme.noticeSoldout.init(variant);
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
          //update availability - available
          $(this.selectors.availability).find('span').text(theme.strings.available);
          $('.product__pickup-availabilities').show();
          const a1 = optionName,
                a2 = variant.options,
                someFunction = (...values) => values.join(' '),
                knownValue = ":",
                output = a1.map((value1, i) => someFunction(value1, knownValue, a2[i]));
          $('.pickup-availability-variant').text(output.join(", "));
          
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
          //update availability - soldout
          $(this.selectors.availability).find('span').text(theme.strings.soldOut);
          $('.product__pickup-availabilities').hide();
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        //update availability - unavailable
        $(this.selectors.availability).find('span').text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
        $('.product__pickup-availabilities').hide();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          var sale_minus = variant.compare_at_price - variant.price;
          var sale_per = sale_minus*100/variant.compare_at_price
          var roundNumber = parseInt(sale_per);
          $(this.selectors.numbersale_change).text(`${roundNumber}%`);
          $(this.selectors.labelwrap_sale).removeClass('hide');

          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
          $(this.selectors.labelwrap_sale).addClass('hide');
        }
        
        //theme.updateCurrencies();
      } else {
        
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_media) {
        var imageId = variant.featured_media.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },
    _updateSwatchTitle: function(e) {
      const {variant} = e; 
			for (var e = 1; e <= e.length; e++) {
        var option = "option" + e;
        $(".js-swatch-display--" + e).text(variant[option])
      }
		},

    _updateStickyCart: function (evt){
      var variant = evt.variant,
          $stickyPrice = $('#js-sticky-price'),
          $stickyTitle = $('#js-sticky-title'),
          $stickyImage = $('#js-sticky-img'),
          $stickyButton = $('#js-sticky-btn');
      if (variant) {
        //update title
        $stickyTitle.html(' - ' + variant.title);
        //update price
        $stickyPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        //update selectbox
        for (var i = 1; i <= 3; i++) {
          var option = 'option' + i,
              $selecBox = '#js-sticky-option-' + i;
          if (variant[option] !== null){
            var valueOption = variant[option];
            $($selecBox).val(valueOption);
          }
        }
        //update button cart
        if (variant.available) {
          $stickyButton.prop('disabled', false).removeClass('btn--sold-out');
          $stickyButton.html(theme.strings.addToCart);
        } else {
          $stickyButton.prop('disabled', true).addClass('btn--sold-out');
          $stickyButton.html(theme.strings.soldOut);
        }
        //update image
        if (variant.featured_image) {
          $stickyImage.attr('src',theme.Images.getSizedImageUrl(variant.featured_image.src,'200x'));
        }
      } else {
        //update title
        $stickyTitle.html(' - ' + theme.strings.unavailable);
        //update button cart
        $stickyButton.prop('disabled', true).removeClass('btn--sold-out');
        $stickyButton.html(theme.strings.unavailable);
      }
    },

    switchProductImage: function(imageId) {
      var $mainWrapper = $(this.selectors.productImageMain, this.$container);
      if ($mainWrapper.hasClass('slick-initialized')) {
        var $slideToShow = $(
          this.selectors.productImageContainers +
            "[data-image-id='" +
            imageId +
            "']",
          this.$container
        )
          .not('.slick-cloned')
          .first();
        var slideIndex = parseInt($slideToShow.attr('data-slick-index'), 10);
        if (!isNaN(slideIndex)) {
          $mainWrapper.slick('slickGoTo', slideIndex, true);
          return;
        }
      }

      var $imageToShow = $(
        this.selectors.productImageContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $imagesToHide = $(
        this.selectors.productImageContainers +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      //$imagesToHide.addClass('hide');
      $imageToShow.removeClass('hide');
      //Scroll to active
      var topMenuHeight = $('.site-header').outerHeight();
      if(this.settings.sectionTem === 'media-list' || this.settings.sectionTem === 'media-grid' || this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2'){
        $([document.documentElement, document.body]).animate({
          scrollTop: $imageToShow.offset().top-topMenuHeight
        }, 600);
      }
    },

    setActiveThumbnail: function(imageId) {
      var $allThumbItems = $(this.selectors.productThumbContainers, this.$container);
      var $matchingThumbItems = $(
        this.selectors.productThumbContainers +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      $allThumbItems.removeClass('is-active');
      $matchingThumbItems.addClass('is-active');

      if (!$matchingThumbItems.length) return;

      var $thumbnailsWrapper = $(this.selectors.productThumbsWrapper, this.$container);
      var $thumbToFocus = $matchingThumbItems.first();

      // If we have duplicates (native infinite-scroll clones), focus the item
      // closest to the current viewport so the highlight stays where the user is.
      if ($matchingThumbItems.length > 1) {
        var $nonClone = $matchingThumbItems.not('.thumb-clone');

        if ($thumbnailsWrapper.hasClass('product-single__thumbnails--scroll')) {
          var wrapperEl = $thumbnailsWrapper[0];
          if (wrapperEl) {
            var wrapperCenter = wrapperEl.scrollLeft + wrapperEl.clientWidth / 2;
            var bestEl = null;
            var bestDistance = Infinity;

            $matchingThumbItems.each(function() {
              var el = this;
              var elCenter = el.offsetLeft + el.offsetWidth / 2;
              var distance = Math.abs(elCenter - wrapperCenter);
              if (distance < bestDistance) {
                bestDistance = distance;
                bestEl = el;
              }
            });

            if (bestEl) {
              $thumbToFocus = $(bestEl);
            }
          }
        } else if ($nonClone.length) {
          $thumbToFocus = $nonClone.first();
        }
      }

      // Preserve old behavior for slick focusOnSelect setups.
      if ($thumbnailsWrapper.hasClass('slick-initialized')) {
        $thumbToFocus.trigger('click');
      }

      if ($thumbnailsWrapper.hasClass('product-single__thumbnails--scroll')) {
        var thumbsWrapperEl = $thumbnailsWrapper[0];
        var thumbEl = $thumbToFocus[0];
        if (thumbsWrapperEl && thumbEl) {
          var wrapperRect = thumbsWrapperEl.getBoundingClientRect();
          var thumbRect = thumbEl.getBoundingClientRect();
          var deltaLeft =
            thumbRect.left +
            thumbRect.width / 2 -
            (wrapperRect.left + wrapperRect.width / 2);
          var targetLeft = thumbsWrapperEl.scrollLeft + deltaLeft;
          var maxScrollLeft =
            thumbsWrapperEl.scrollWidth - thumbsWrapperEl.clientWidth;
          thumbsWrapperEl.scrollLeft = Math.max(
            0,
            Math.min(targetLeft, maxScrollLeft)
          );
        }
      }

      // If there is a slick carousel, get the slide index, and position it into view with animation.
      if ($thumbnailsWrapper.hasClass('slick-initialized')) {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var currentActiveSlideIndex = $thumbnailsWrapper.slick('slickCurrentSlide');
        var newActiveSlideIndex = parseInt(
          $thumbToFocus.attr('data-slick-index')
        );
        if (currentActiveSlideIndex !== newActiveSlideIndex) {
          $thumbnailsWrapper.slick('slickGoTo', newActiveSlideIndex, false);
        }
      }

    },

    _productZoomImage: function() {
      // The zoom image is only used on the product template, so return early
      // even if a featured product section is present.
      if (
        !$('.product-single ' + this.selectors.productImageContainers).length
      ) {
        return;
      }

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          // Empty src before loadig new image to avoid awkward image swap
          $(self.selectors.productZoomImage)
            .attr('src', '')
            .attr('src', $(this).attr('href'));
        }
      );

      this.ProductModal = new window.Modals(
        this.selectors.modal,
        'product-modal'
      );

      // Close modal if clicked, but not if the image is clicked
      this.ProductModal.$modal.on('click' + this.settings.namespace, function(
        evt
      ) {
        if (evt.target.nodeName !== 'IMG') {
          self.ProductModal.close();
        }
      });
    },

    _productThumbSwitch: function() {
      if (!$(this.selectors.productThumbs).length) {
        return;
      }

      if (this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2') {
        return;
      }

      var self = this;

      $(this.selectors.productThumbs).on(
        'click' + this.settings.namespace,
        function(evt) {
          evt.preventDefault();
          var imageId = $(this)
            .parent()
            .data('image-id');
          self.setActiveThumbnail(imageId);
          self.switchProductImage(imageId);
        }
      );
      //trigger hover thumb
      // $(this.selectors.productThumbs).on('click',function(){
      //   $(this).trigger('click');
      // });
    },
    _bindCollageThumbLightbox: function() {
      var $thumbs = $(this.selectors.productThumbs);
      var sectionId = this.settings.sectionId;
      if (!$thumbs.length) return;

      $thumbs.on('click' + this.settings.namespace, function(evt) {
        evt.preventDefault();
        var imageId = $(this).parent().data('image-id');
        var $gallery = $('.gallery-wrap' + sectionId);
        var $targetFigure = $gallery.find('.photo-image[data-image-id="' + imageId + '"]').not('.slick-cloned').first();
        if ($targetFigure.length) {
          if (typeof window.openPhotoSwipe === 'function') {
            var $galleryItems = $gallery.find('.photo-image').not('.slick-cloned');
            var index = $galleryItems.index($targetFigure);
            window.openPhotoSwipe(index, $gallery[0]);
          } else {
            $targetFigure.trigger('click');
          }
        }
      });
    },

    /*
      Thumbnail slider
     */
    _productThumbnailSlider: function() {
      var $productThumbsWrapper = $(this.selectors.productThumbsWrapper);
      var $productMainWrapper = $(this.selectors.productImageMain);
      var $productThumbs = $(this.selectors.productThumbs);
      var self = this;
      var useFadeEffect = this.settings.mediaEffect !== 'slide';
      if (!$productThumbs.length) {
        return;
      }

      if ($productThumbs.length > 1) {
        function centerThumbInScrollWrapper(thumbsWrapperEl, thumbEl) {
          if (!thumbsWrapperEl || !thumbEl) return;
          var wrapperRect = thumbsWrapperEl.getBoundingClientRect();
          var thumbRect = thumbEl.getBoundingClientRect();
          var deltaLeft =
            thumbRect.left +
            thumbRect.width / 2 -
            (wrapperRect.left + wrapperRect.width / 2);
          var targetLeft = thumbsWrapperEl.scrollLeft + deltaLeft;
          var maxScrollLeft = thumbsWrapperEl.scrollWidth - thumbsWrapperEl.clientWidth;
          thumbsWrapperEl.scrollLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));
        }

        function initInfiniteThumbScroll($wrapper) {
          if (!$wrapper || !$wrapper.length) return;
          if ($wrapper.data('infiniteThumbScroll')) return;

          var wrapperEl = $wrapper[0];
          var $items = $wrapper.children('.product-single__thumbnail-item');
          if (!wrapperEl || $items.length < 2) return;

          var viewWidth = wrapperEl.clientWidth;
          var loopWidth = wrapperEl.scrollWidth;
          if (!viewWidth || !loopWidth) return;

          // If there isn't enough content to meaningfully scroll, don't create a loop.
          // This prevents obvious duplicates when the strip can already fit in view.
          if (loopWidth <= viewWidth + 1) return;

           var firstItemEl = $items[0];
           if (firstItemEl && typeof firstItemEl.getBoundingClientRect === 'function') {
             // Only enable "infinite" mode when there are enough thumbnails.
             // With too few items, cloning creates obvious duplicates.
             var itemStep = firstItemEl.getBoundingClientRect().width || 0;
             if ($items.length > 1) {
               var secondItemEl = $items[1];
               var step = secondItemEl.offsetLeft - firstItemEl.offsetLeft;
               if (step > 0) {
                 itemStep = step;
               }
             }

             if (!itemStep) return;
             var approxVisible = Math.ceil(viewWidth / itemStep);
             var minItemsForLoop = Math.max(8, approxVisible + 3);
             if ($items.length < minItemsForLoop) return;
           }

          var $before = $items.clone(true, true).addClass('thumb-clone');
          var $after = $items.clone(true, true).addClass('thumb-clone');
          $before
            .removeClass('is-active')
            .attr('aria-hidden', 'true')
            .find('a')
            .attr('tabindex', '-1');
          $after
            .removeClass('is-active')
            .attr('aria-hidden', 'true')
            .find('a')
            .attr('tabindex', '-1');

          $wrapper.prepend($before);
          $wrapper.append($after);

          $wrapper.data('infiniteThumbScroll', true);
          $wrapper.data('infiniteThumbLoopWidth', loopWidth);

          wrapperEl.scrollLeft = wrapperEl.scrollLeft + loopWidth;

          var isPointerDown = false;
          var scrollEndTimer = null;
          var isAdjusting = false;

          function recenterIfNeeded() {
            if (isPointerDown || isAdjusting) return;
            var width = $wrapper.data('infiniteThumbLoopWidth') || 0;
            if (!width) return;

            var left = wrapperEl.scrollLeft;
            if (left < width) {
              isAdjusting = true;
              wrapperEl.scrollLeft = left + width;
              isAdjusting = false;
            } else if (left > width * 2) {
              isAdjusting = true;
              wrapperEl.scrollLeft = left - width;
              isAdjusting = false;
            }
          }

          function scheduleRecenter() {
            if (scrollEndTimer) {
              clearTimeout(scrollEndTimer);
            }
            scrollEndTimer = setTimeout(recenterIfNeeded, 80);
          }

          $wrapper.on('scroll' + self.settings.namespace, function() {
            scheduleRecenter();
          });

          $wrapper.on(
            'touchstart' + self.settings.namespace + ' mousedown' + self.settings.namespace,
            function() {
              isPointerDown = true;
              if (scrollEndTimer) clearTimeout(scrollEndTimer);
            }
          );

          $wrapper.on(
            'touchend' +
              self.settings.namespace +
              ' mouseup' +
              self.settings.namespace +
              ' touchcancel' +
              self.settings.namespace +
              ' mouseleave' +
              self.settings.namespace,
            function() {
              isPointerDown = false;
              scheduleRecenter();
            }
          );

          $(window).on('resize' + self.settings.namespace, function() {
            if (!$wrapper.data('infiniteThumbScroll')) return;
            var newWidth = wrapperEl.scrollWidth / 3;
            if (!newWidth) return;
            $wrapper.data('infiniteThumbLoopWidth', newWidth);

            var left = wrapperEl.scrollLeft;
            if (left < newWidth) {
              wrapperEl.scrollLeft = left + newWidth;
            } else if (left > newWidth * 2) {
              wrapperEl.scrollLeft = left - newWidth;
            }
          });
        }

        function attachThumbScrollbar($wrapper) {
          if (!$wrapper || !$wrapper.length) return;
          if ($wrapper.data('thumbScrollbar')) return;

          var $track = $('<div class="product-thumb-scrollbar" aria-hidden="true"></div>');
          var $bar = $('<div class="product-thumb-scrollbar__bar"></div>');
          $track.append($bar);
          $wrapper.append($track);
          $wrapper.data('thumbScrollbar', true);

          var hideTimer = null;

          function updateBar() {
            var el = $wrapper[0];
            if (!el) return;
            var hasLoop = !!$wrapper.data('infiniteThumbScroll');
            var loopWidth = hasLoop ? $wrapper.data('infiniteThumbLoopWidth') : null;
            var baseScrollWidth = hasLoop && loopWidth ? loopWidth : el.scrollWidth;
            var maxScroll = baseScrollWidth - el.clientWidth;
            if (maxScroll <= 0) {
              $track.removeClass('is-visible');
              return false;
            }

            var trackWidth = $track[0] ? $track[0].clientWidth : el.clientWidth;
            if (!trackWidth) return false;

            var currentLeft = el.scrollLeft;
            if (hasLoop && baseScrollWidth) {
              currentLeft = currentLeft % baseScrollWidth;
              if (currentLeft < 0) currentLeft += baseScrollWidth;
            }

            var ratio = el.clientWidth / baseScrollWidth;
            var barWidth = Math.max(16, trackWidth * ratio);
            barWidth = Math.min(barWidth, trackWidth);

            var maxOffset = trackWidth - barWidth;
            var offset = maxOffset > 0 ? (currentLeft / maxScroll) * maxOffset : 0;

            $bar.css({
              width: barWidth + 'px',
              transform: 'translateX(' + offset + 'px)'
            });
            return true;
          }

          function showBar() {
            var hasScroll = updateBar();
            if (!hasScroll) {
              return;
            }
            $track.addClass('is-visible');
            if (hideTimer) {
              clearTimeout(hideTimer);
            }
            hideTimer = setTimeout(function() {
              $track.removeClass('is-visible');
            }, 450);
          }

          $wrapper.on('scroll' + self.settings.namespace, showBar);
          $wrapper.on(
            'touchstart' +
              self.settings.namespace +
              ' mousedown' +
              self.settings.namespace +
              ' mouseenter' +
              self.settings.namespace,
            function() {
              showBar();
            }
          );

          $(window).on('resize' + self.settings.namespace, updateBar);
          updateBar();
        }

        var isCollageCarousel = this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2';
        var isCollageTemplate = this.settings.template === 'product.collage-s1';
        var disableThumbToMainSync = isCollageTemplate;
        var useNativeThumbScroll = disableThumbToMainSync && this.settings.sectionTem !== 'media-left' && this.settings.sectionTem !== 'media-right';
        var disableCustomThumbScrollbar = isCollageTemplate && window.innerWidth <= this.settings.smallBreakpoint;
        var enableInfiniteThumbLoop = useNativeThumbScroll && !disableThumbToMainSync;
        var thumbsNavTarget = !isCollageCarousel && !disableThumbToMainSync ? $productMainWrapper : null;
        var mainNavTarget = isCollageCarousel || useNativeThumbScroll ? null : $productThumbsWrapper;
        var initialActiveImageId = $productThumbsWrapper.find('.is-active').data('image-id');

        if (useNativeThumbScroll) {
          $productThumbsWrapper
            .addClass('product-single__thumbnails--scroll')
            .css('opacity', '1');
          // Keep collage-s1 thumbnails native to avoid duplicated content and keep the overlay bar in sync.
          if (enableInfiniteThumbLoop) {
            initInfiniteThumbScroll($productThumbsWrapper);
          }
          if (!disableCustomThumbScrollbar) {
            attachThumbScrollbar($productThumbsWrapper);
          }
          var $activeThumbItem = $productThumbsWrapper
            .find('.product-single__thumbnail-item.is-active')
            .not('.thumb-clone')
            .first();
          centerThumbInScrollWrapper($productThumbsWrapper[0], $activeThumbItem[0]);
        }
        if (!isCollageCarousel) {
          $productThumbsWrapper.on(
            'init' + this.settings.namespace,
            this._productSwipeInit.bind(this)
          );
        }
        if (this.settings.sectionTem === 'media-left' || this.settings.sectionTem === 'media-right'){
          if (!useNativeThumbScroll) {
            $productThumbsWrapper.slick({
              accessibility: true,
              arrows: true,
              dots: false,
              infinite: false,
              autoplay: false,
              slidesToShow: 5,
              slidesToScroll: 1,
              focusOnSelect: true,
              swipeToSlide: true,
              touchMove: true,
              touchThreshold: 10,
              waitForAnimate: false,
              speed: 400,
              cssEase: 'ease-in-out',
              asNavFor: thumbsNavTarget,
              vertical: true,
              verticalSwiping: true,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                  }
                }
              ]
            }).css('opacity','1');
          }
          slideMain();
        }
        else if (this.settings.sectionTem === 'media-nothumb'){
          if (!useNativeThumbScroll) {
            $productThumbsWrapper.slick({
              accessibility: true,
              arrows: true,
              dots: false,
              infinite: false,
              autoplay: false,
              slidesToShow: 6,
              slidesToScroll: 1,
              focusOnSelect: true,
              swipeToSlide: true,
              touchMove: true,
              touchThreshold: 10,
              waitForAnimate: false,
              speed: 400,
              cssEase: 'ease-in-out',
              asNavFor: thumbsNavTarget,
              responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                }
              ]
            }).css('opacity','1');
          }
          slideMain();
        }
        else if (this.settings.sectionTem === 'media-list' || this.settings.sectionTem === 'media-grid' || this.settings.sectionTem === 'media-collage-1' || this.settings.sectionTem === 'media-collage-2'){
          var thumbResponsiveSettings = [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            }
          ];
          if (!isCollageCarousel) {
            thumbResponsiveSettings.unshift({
              breakpoint: 9999,
              settings: 'unslick'
            });
          }
          if (!useNativeThumbScroll) {
            $productThumbsWrapper.slick({
              accessibility: true,
              arrows: true,
              dots: false,
              infinite: true,
              autoplay: false,
              slidesToShow: 6,
              slidesToScroll: isCollageCarousel ? 2 : 1,
              focusOnSelect: !isCollageCarousel,
              swipeToSlide: true,
              touchMove: true,
              touchThreshold: 10,
              edgeFriction: 0.15,
              waitForAnimate: false,
              speed: 400,
              cssEase: 'ease-in-out',
              asNavFor: thumbsNavTarget,
              responsive: thumbResponsiveSettings
            }).css('opacity','1');
          } else {
            $productThumbsWrapper.css('opacity', '1');
          }
          var mainResponsiveSettings = [];
          if (useFadeEffect) {
            mainResponsiveSettings.push({
              breakpoint: this.settings.smallBreakpoint,
              settings: {
                fade: false,
                cssEase: 'ease-in-out'
              }
            });
          }
          mainResponsiveSettings.push({
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          });
          if (!isCollageCarousel) {
            mainResponsiveSettings.unshift({
              breakpoint: 9999,
              settings: 'unslick'
            });
          }
          $productMainWrapper.slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: useFadeEffect,
            adaptiveHeight: true,
            accessibility: true,
            draggable: true,
            touchThreshold: 10,
            waitForAnimate: false,
            speed: 450,
            cssEase: useFadeEffect ? 'linear' : 'ease-in-out',
            asNavFor: mainNavTarget,
            responsive: mainResponsiveSettings
          }).css('opacity','1');
          if (!useNativeThumbScroll) {
            $productThumbsWrapper.slick(
              'slickGoTo',
              $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
              true
            );
            $(window).on('resize', function() {
              $productThumbsWrapper.slick('resize');
              $productMainWrapper.slick('resize');
            });
          } else {
            $(window).on('resize', function() {
              $productMainWrapper.slick('resize');
            });
          }
        }
        else{
          if (!useNativeThumbScroll) {
            $productThumbsWrapper.slick({
              accessibility: true,
              arrows: true,
              dots: false,
              infinite: false,
              autoplay: false,
              slidesToShow: 6,
              slidesToScroll: 1,
              focusOnSelect: true,
              swipeToSlide: true,
              touchMove: true,
              touchThreshold: 10,
              waitForAnimate: false,
              speed: 400,
              cssEase: 'ease-in-out',
              asNavFor: thumbsNavTarget,
              responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                  }
                }
              ]
            }).css('opacity','1');
          } else {
            $productThumbsWrapper.css('opacity', '1');
          }
          slideMain();
        }
        function slideMain(){
          var slideResponsiveSettings = [];
          if (useFadeEffect) {
            slideResponsiveSettings.push({
              breakpoint: self.settings.smallBreakpoint,
              settings: {
                fade: false,
                cssEase: 'ease-in-out',
                draggable: true,
                swipe: true,
                touchThreshold: 10
              }
            });
          }
          $productMainWrapper.slick({
            arrows: true,
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: useFadeEffect,
            adaptiveHeight: true,
            accessibility: true,
            draggable: !useFadeEffect,
            swipe: !useFadeEffect,
            touchThreshold: 10,
            speed: 450,
            cssEase: useFadeEffect ? 'linear' : 'ease-in-out',
            asNavFor: mainNavTarget,
            responsive: slideResponsiveSettings
          }).css('opacity','1');
          }
        }
        // Show highlighted thumbnail by repositioning slider
        if(!useNativeThumbScroll && (this.settings.sectionTem === 'media-left' || this.settings.sectionTem === 'media-right' || this.settings.sectionTem === 'media-nothumb' || this.settings.sectionTem === 'media-bottom')){
          $productThumbsWrapper.slick(
            'slickGoTo',
            $productThumbsWrapper.find('.is-active').attr('data-slick-index'),
            true
          );
        }

        if (disableThumbToMainSync && initialActiveImageId && $productMainWrapper.hasClass('slick-initialized')) {
          self.switchProductImage(initialActiveImageId);
        }

        if (disableThumbToMainSync) {
          $productMainWrapper.on('afterChange' + this.settings.namespace, function(evt, slick, currentSlide) {
            var $activeSlide = $productMainWrapper
              .find(self.selectors.productImageContainers + "[data-slick-index='" + currentSlide + "']")
              .not('.slick-cloned')
              .first();
            var activeImageId = $activeSlide.data('image-id');
            if (activeImageId) {
              self.setActiveThumbnail(activeImageId);
            }
          });
        }
        
        
    },

    _productSwipeInit: function(evt, obj) {
      // Slider is initialized. Setup custom swipe events
      this.settings.productThumbIndex = obj.currentSlide;
      this.settings.productThumbMax = obj.slideCount - 1; // we need the 0-based index

      var self = this;

      $(this.selectors.productImageWrappers).on(
        'swipeleft swiperight',
        function(event) {
          if (event.type === 'swipeleft') {
            self._goToNextThumbnail();
          }

          if (event.type === 'swiperight') {
            self._goToPrevThumbnail();
          }

          // Trigger click on newly requested thumbnail
          $(
            '.product-single__thumbnail-item[data-slick-index="' +
              self.settings.productThumbIndex +
              '"]'
          )
            .find('.product-single__thumbnail')
            .trigger('click');
          
        }
      );
    },
    _goToNextThumbnail: function() {
      this.settings.productThumbIndex++;

      if (this.settings.productThumbIndex > this.settings.productThumbMax) {
        this.settings.productThumbIndex = 0;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _goToPrevThumbnail: function() {
      this.settings.productThumbIndex--;

      if (this.settings.productThumbIndex < 0) {
        this.settings.productThumbIndex = this.settings.productThumbMax;
      }

      $(this.selectors.productThumbsWrapper).slick(
        'slickGoTo',
        this.settings.productThumbIndex,
        true
      );
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      $(window).off(this.settings.namespace);
      $(this.selectors.productImageWrappers).off(this.settings.namespace);
      $(this.selectors.productThumbs).off(this.settings.namespace);
      var $thumbsWrapper = $(this.selectors.productThumbsWrapper, this.$container);
      $thumbsWrapper.off(this.settings.namespace);
      if ($thumbsWrapper.hasClass('slick-initialized')) {
        $thumbsWrapper.slick('unslick');
      }
      var $mainWrapper = $(this.selectors.productImageMain, this.$container);
      $mainWrapper.off(this.settings.namespace);
      if ($mainWrapper.hasClass('slick-initialized')) {
        $mainWrapper.slick('unslick');
      }
      if (this.ProductModal) {
        this.ProductModal.$modal.off(this.settings.namespace);
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    dots: '.slick-dots',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    this.navArrow = this.$slideshow.data('arrow');
    this.navDot = this.$slideshow.data('dot');
    this.transit = this.$slideshow.data('transit');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
    this.settings = {
      rtl:theme.rtl,
      accessibility: false,
      arrows: this.navArrow,
      dots:  this.navDot,
      fade:  (this.transit === 'slide' ? false : true),
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      pauseOnFocus: this.autorotate? false:true, 
      pauseOnHover: this.autorotate? false:true,
      useTransform: true,
      infinite: true,
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);
    this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ($(this).data('transit') === 'slide-fade' ) {
          var $outGoing = $(slick.$slides.get(currentSlide));
          $outGoing.addClass('slick-going');
        }
    });
    this.$slideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $(slick.$slides).filter('.slick-going').removeClass('slick-going');
    });
    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();
    
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

//     this.$wrapper.on('keyup', keyboardNavigation.bind(this));
//     this.$controls.on('keyup', keyboardNavigation.bind(this));
//     this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');
    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

//   function keyboardNavigation() {
//     if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
//       this.$slideshow.slick('slickPrev');
//     }
//     if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
//       this.$slideshow.slick('slickNext');
//     }
//   }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
          
      });
      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
          
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.noteCart = (function() {
  if($('.block-notecart') != undefined ){
    var $el = $('#cart__note');
    var $btnsubmit = $('.cart-notes-submit');
    var $editNote = $('.edit-notecart');
    var $closeNote = $('.cart-note-close');
    var $drawCart = $('.mini-cart-content');
    var noteText;
    function noteUpdate(noteText){
        params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + theme.attributeToString(noteText)
        };
        $.ajax(params);
    }
    $btnsubmit.on( "click", function() {
      noteText = $el.val();
      noteUpdate(noteText);
      $(this).closest('.js-note-cart').removeClass('active');
    });
    $editNote.on( "click", function() {
      $(this).siblings().toggleClass('active');
      $(this).closest($drawCart).toggleClass('overlay');
    });
    $closeNote.on( "click", function() {
      $(this).closest('.js-note-cart').removeClass('active');
      $(this).closest($drawCart).removeClass('overlay');
    });
  }
  
})();
theme.attributeToString = function(attribute) {
	if (typeof attribute !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
}

// Instagrams
theme.Instagrams = (function() {
  function Instagrams(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    //console.log(this.$container);
    this.settings = {
      style 			: this.$container.data('style'),
      accesstoken 		: this.$container.data('accesstoken'),
      userid			: this.$container.data('userid'),
      limit 			: this.$container.data('limit'),
      resolution 		: this.$container.data('resolution'),
      target 			: this.$container.attr('id'),
      rows 			: this.$container.data('rows'),
      
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      draggable 		: this.$container.data('draggable') || false,
      dots 				: this.$container.data('dots') || false,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= 2;
    
    var _self = this;
    var $instagramSelector = $('#'+this.settings.target);
    if (this.settings.style === 'grid'){
      var afterInstagram = function(){} // blank function
    }else if (this.settings.style === 'carousel'){
      var afterInstagram = function(){
        $instagramSelector.slick({
          slidesToShow		: _self.settings.slidesToShow,
          slidesToScroll	: _self.settings.slidesToShow,
          arrows			: _self.settings.arrows,
          dots				: _self.settings.dots,
          draggable		 	: _self.settings.draggable,
          infinite		 	: _self.settings.infinite,
          rows : _self.settings.rows,
          accessibility:false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow	: _self.settings.slidesToShow1200,
                slidesToScroll	: _self.settings.slidesToShow1200,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow	: _self.settings.slidesToShow992,
                slidesToScroll	: _self.settings.slidesToShow992,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow	: _self.settings.slidesToShow768,
                slidesToScroll	: _self.settings.slidesToShow768,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow	: _self.settings.slidesToShow480,
                slidesToScroll	: _self.settings.slidesToShow480,
              }
            }
          ]
        })
      }
    }

    var feed = new Instafeed({
      get			: 'user',
      target 		: this.settings.target,
      userId		: this.settings.userid,
      accessToken	: this.settings.accesstoken,
      limit			: this.settings.limit,
      resolution	: this.settings.resolution,
      template		: '<div class="col hv-image-brightness"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="transition lazyload" data-src="{{image}}" /></a></div>',
      after			: afterInstagram
    });

    feed.run();
  }

  Instagrams.prototype = _.assignIn({}, Instagrams.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Instagrams;
})();

// Slick carousel
theme.slickCarousel = (function (){
  function Carousels(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      rows 				: this.$container.data('rows') || 1,
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      slidesToScroll	: this.$container.data('slidestoscroll') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      autoplay 			: this.$container.data('autoplay') || false,
      draggable 		: this.$container.data('draggable') || false,
      accessibility 	: this.$container.data('accessibility') || false,
      slidesToShowMobile 		: this.$container.data('slidestoshow-mobile') || 1,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= (this.settings.slidesToShow - 4) > 1? (this.settings.slidesToShow - 4) : 1;
    this.settings.slidesToScroll1200 	= (this.settings.slidesToScroll - 1) > 1? (this.settings.slidesToScroll - 1) : 1;
    this.settings.slidesToScroll992  	= (this.settings.slidesToScroll - 2) > 1? (this.settings.slidesToScroll - 2) : 1;
    this.settings.slidesToScroll768  	= (this.settings.slidesToScroll - 3) > 1? (this.settings.slidesToScroll - 3) : 1;
    this.settings.slidesToScroll480  	= (this.settings.slidesToScroll - 4) > 1? (this.settings.slidesToScroll - 4) : 1;
    this.$container.slick({
      rtl				: theme.rtl,
      rows 				: this.settings.rows,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll 	: this.settings.slidesToScroll,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: this.settings.autoplay,
      accessibility		: this.settings.accessibility,
      draggable			: this.settings.draggable,
      infinite			: this.settings.infinite,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.settings.slidesToShow1200,
            slidesToScroll: this.settings.slidesToScroll1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: this.settings.slidesToShow992,
            slidesToScroll: this.settings.slidesToScroll992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: this.settings.slidesToShow768,
            slidesToScroll: this.settings.slidesToScroll768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: this.settings.slidesToShowMobile,
            slidesToScroll: this.settings.slidesToShowMobile
          }
        }
      ]
    }).css('opacity','1');
   
    if($('.shopthelook').length){
      var $container = (this.$container = $(container)),
          sectionId = $container.attr('data-section-id'),
          $dotID = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find("li");
          $dotID.click(function(){
            var pos = $(this).data('pos');
            $dotID.removeClass('active');
            $(this).addClass("active");
            $container.slick("slickGoTo", pos);
          });
          $container.on('afterChange', function(event, slick, currentSlide, nextSlide){
              var $dotPos = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find(`li[data-pos=${currentSlide}]`);
              $dotID.removeClass('active');
              $dotPos.addClass('active');
          });
    }
    
  }

  Carousels.prototype = _.assignIn({}, Carousels.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
      
    }
  });

  return Carousels;
})()

// Slick Press
theme.slickPress = (function (){
  function slickPress(container) {

    this.$container = $(container).on('init', this._a11y.bind(this));
    var sectionId = this.$container.data('section-id');
    var pressSub = '#sub-'+ sectionId;
    
    this.settings = {
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
    }
      this.$container.slick({
      rtl				: theme.rtl,
      rows 				: 1,
      slidesToShow		: 1,
      slidesToScroll 	: 1,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: false,
      accessibility		: true,
      draggable			: true,
      infinite			: true,
      adaptiveHeight: true,
      asNavFor: pressSub,
      
    }).css('opacity','1');

    $(pressSub).slick({
      slidesToShow		: 3,
      slidesToScroll 	: 1,
      infinite			: true,
      arrows			: false,
      asNavFor: this.$container,
      draggable			: true,
      accessibility		: true,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0px',
    });
  }

  slickPress.prototype = _.assignIn({}, slickPress.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container;
      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete  this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
      
    }
  });

  return slickPress;
})()

// Productlists
theme.Productlists = (function() {
  function Productlists(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      rows 				: this.$container.data('rows') || 1,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      draggable 		: this.$container.data('draggable') || false,
      infinite 			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 1.5;
    this.$container.slick({
      rtl				: theme.rtl,
      accessibility		: false,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll	: this.settings.slidesToShow,
      rows				: this.settings.rows,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      infinite 			: this.settings.infinite,
      draggable			: this.settings.draggable,
      responsive		: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow	: this.settings.slidesToShow1200,
            slidesToScroll	: this.settings.slidesToShow1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow	: this.settings.slidesToShow992,
            slidesToScroll	: this.settings.slidesToShow992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow	: this.settings.slidesToShow768,
            slidesToScroll	: this.settings.slidesToShow768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow	: this.settings.slidesToShow480,
            slidesToScroll	: this.settings.slidesToShow480
          }
        }
      ]
    }).css('opacity','1');
  }

  Productlists.prototype = _.assignIn({}, Productlists.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    }
  });

  return Productlists;
})();

// Producttabs
theme.Producttabs = (function() {
  function Producttabs(container) {
    var _self = this; // avoid conflict
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.slickWrap 	= '.prdtab-content';
    this.settings 	= {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      arrows 			: this.$container.data('arrows') || false,
      rows 				: this.$container.data('rows') || 1,
      dots 				: this.$container.data('dots') || false,
      draggable			: this.$container.data('draggable') || false,
      infinite			: false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 1.5;

    this._initSlick();
    this.$container.find('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
      _self._unSlick();
      _self._initSlick();
      theme.tooltip.load();
    })
  }

  Producttabs.prototype = _.assignIn({}, Producttabs.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _getSliderSettings : function (){
      return {
        rtl				: theme.rtl,
        accessibility	: true,
        slidesToShow	: this.settings.slidesToShow,
        slidesToScroll	: this.settings.slidesToShow,
        arrows			: this.settings.arrows,
        rows			: this.settings.rows,
        dots			: this.settings.dots,
        infinite 		: this.settings.infinite,
        draggable		: this.settings.draggable,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: this.settings.slidesToShow1200,
              slidesToScroll: this.settings.slidesToShow1200
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: this.settings.slidesToShow992,
              slidesToScroll: this.settings.slidesToShow992
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.settings.slidesToShow768,
              slidesToScroll: this.settings.slidesToShow768
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: this.settings.slidesToShow480,
              slidesToScroll: this.settings.slidesToShow480
            }
          }
        ]
      }
    },

    _initSlick : function (){
      this.$container.find(this.slickWrap).slick(this._getSliderSettings()).css('opacity','1');
    },

    _unSlick : function(){
      this.$container.find(this.slickWrap).slick('unslick');
    },

    onUnload: function() {
      delete this.$container;
    },

    onSelect: function() {
      this._unSlick();
      this._initSlick();
    },

    onBlockSelect: function(evt) {
      var navItem = $('.nav-link-' + evt.detail.blockId);
      navItem.tab('show');
      this._unSlick();
      this._initSlick();
    }
  });

  return Producttabs;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function() {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function() {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function() {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();


theme.SwiperCustom = (function() {
  function SwiperCustom(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.nav = '.swiper-wrapper-' + this.sectionId;
    this.namespace = '.swipercol-' + this.sectionId;
    var perviewDesktop = parseFloat($(container).data('perview-desktop'));
    var perviewMobile = parseFloat($(container).data('perview-mobile'));
    var spaceBetweenData = $(container).data('space-between');
    var spaceBetween = parseInt(spaceBetweenData, 10);
    var mobileSpaceBetween = 10;

    if (isNaN(perviewDesktop) || perviewDesktop <= 0) {
      perviewDesktop = 4;
    }

    if (isNaN(perviewMobile) || perviewMobile <= 0) {
      perviewMobile = 1;
    }

    if (isNaN(spaceBetween)) {
      spaceBetween = 0;
    }

    if (spaceBetweenData !== undefined) {
      if (spaceBetween <= 0) {
        mobileSpaceBetween = 0;
      } else if (spaceBetween < mobileSpaceBetween) {
        mobileSpaceBetween = spaceBetween;
      }
    }

    var desktopSlides = perviewDesktop;
    var mobileSlides = Math.min(perviewMobile, desktopSlides);
    var tabletSlides = Math.max(Math.ceil(perviewMobile), 3);

    if (tabletSlides > desktopSlides) {
      tabletSlides = desktopSlides;
    }

    var swiper = new Swiper(this.namespace, {
      slidesPerView: desktopSlides,
      freeMode: false,
      autoHeight: true,
      calculateHeight:true,
      freeModeSticky: true,
      centeredSlides: false,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      spaceBetween: spaceBetween,
      observer: true,
      observeParents: true,
      parallax:true,
      a11y: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          centeredSlides: mobileSlides <= 1,
          centeredSlidesBounds: mobileSlides <= 1,
          spaceBetween: mobileSpaceBetween
        },
        576: {
          slidesPerView: mobileSlides,
          centeredSlides: mobileSlides <= 1,
          centeredSlidesBounds: mobileSlides <= 1
        },
        768: {
          slidesPerView: tabletSlides,
          centeredSlides: false,
          centeredSlidesBounds: false
        },
        992: {
          slidesPerView: desktopSlides,
          centeredSlides: false,
          centeredSlidesBounds: false,
          spaceBetween: spaceBetween
        },
      },
      scrollbar: {
        el: $(this.namespace).find(".swiper-scrollbar")[0],
      },
      navigation: {
        nextEl: $(this.nav).find(".swiper-button-next")[0],
        prevEl: $(this.nav).find(".swiper-button-prev")[0],
      },
    });
   
  }
  return SwiperCustom;
})();


theme.AnnouncementSwiper = (function() {
  function AnnouncementSwiper(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.announswipercol-' + this.sectionId;
    var rootElement = document.querySelector(':root');
    var anNounBar = document.querySelector('.announcement-bar-carousel');
    rootElement.style.setProperty("--height-announbar", anNounBar.offsetHeight + "px");
    var swiper = new Swiper(this.namespace, {
      slidesPerView:1,
      loop: $(this.namespace).find(".slider .slide").length == 1 ? true: false,
      autoHeight: true,
      calculateHeight:true,
      observer: true,
      a11y: true,
      navigation: {
        nextEl: $(this.namespace).find(".swiper-button-next")[0],
        prevEl: $(this.namespace).find(".swiper-button-prev")[0],
      }
    });
    document.addEventListener('shopify:block:select', function (event) {
      var sectionId = event.detail.sectionId;
      var blockId = event.detail.blockId;
      var load = event.detail.load;
      var index = $(`#${blockId}`).index();
      swiper.slideTo(index);
    });
  }
  return AnnouncementSwiper;
})();

theme.init = function() {
  theme.customerTemplates.init();
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });


    //scroll animation
    
  AOS.init({
    startEvent: 'DOMContentLoaded',
    offset: 30, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 700,
    once: true
  });
  
  window.addEventListener('load', function() {
    AOS.refresh();
  });
  document.querySelectorAll('img')
    .forEach((img) =>
        img.addEventListener('load', () =>
            AOS.refresh()
        )
    );
  


  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('cart', theme.Cart);
  sections.register('instagrams', theme.Instagrams);
  sections.register('productlist', theme.Productlists);
  sections.register('producttab', theme.Producttabs);
  sections.register('slickCarousels', theme.slickCarousel);
  sections.register('slickPress', theme.slickPress);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);
  sections.register('bgcollection',theme.Bgcollection);
  sections.register('swipercustom',theme.SwiperCustom);
  sections.register('announcementswiper',theme.AnnouncementSwiper);
  sections.register('cookie', theme.CookieSection);
  sections.register('popupnewletter', theme.popupNewletter);
  sections.register('beforeafter', theme.BeforeAfter);
  sections.register('bundleproduct', theme.bundleProduct);
  sections.register('footer', theme.FooterSection);
  sections.register('promo-code', theme.CouponCode);
  

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

// Quickview https://github.com/kellyvaughn/quickview-for-shopify/blob/master/quickview.js.liquid
theme.quickview = (function() {
  var product_handle = '',
      quickviewButtonClass = '.js-btn-quickview',
      quickviewId = '#jsQuickview',
      quickviewOption = '#jsQuickview select',
      quickviewThumb = '#qv-product-images',
      quickviewAddCartButton = '.qv-add-button',
      quickviewPrice = '.qv-product-price',
      quickviewComparePrice = '.qv-product-compare-price';
      quickLoad = '#loading_qv';
      quickQty = '.popup-quantity';
  // 1. Show quickview
  $(quickLoad).removeClass('activeload');
  $(quickviewId).removeClass('loadqvpopup');

  //quanity quickview
  
  $(".qv-qtity").on("click", function () {
    var $button = $(this);
    var oldValue = $button.closest(quickQty).find("input.qv-quantity").val();
    if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }
    $button.closest(quickQty).find("input.qv-quantity").val(newVal);
  });
  //click
  $(document).on('click',quickviewButtonClass, function() {
    $(quickQty).find("input.qv-quantity").val(1);
    //ResetQuickview
    $(quickLoad).addClass('activeload');
    var qv_color = $(quickviewId).data('color');
    var quickviewAvaible = $(this).attr("data-pavailable");
    var jdmgReview = $(this).attr("data-viewjdmg");
    product_handle = $(this).data('handle');
    $(quickviewThumb).removeClass().empty();
    $('.qv-product-options').empty().removeClass('pb-3');
    var desc = $(this).find('.txt-short').text();
    
    //Pushdata
    $(quickviewId).addClass(product_handle).data('handle',product_handle);
      $.getJSON({
        url: '/products/' + product_handle + '.js?' + new Date().getTime(),
        beforeSend: function() {
          $(quickviewButtonClass+`[data-handle=${product_handle}]`).addClass('qv-loading');
        },
        
      }).done(function(product) {
        $(quickviewId).removeClass().addClass('modal fade show loadqvpopup');
        var title = product.title;
        var type = product.type;
        var vendor = product.vendor;
        var price = 0;
        var compare_price = 0;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        
        $('.qv-product-title').text(title);
        function renderReview(){
          if(window.SPR &&  theme.review ){
            $('.qv-product-rv').html(`<span class="shopify-product-reviews-badge" data-id="${product.id}"></span>`);
            return window.SPR.registerCallbacks(),
            window.SPR.initRatingHandler(),
            window.SPR.initDomEls(),
            window.SPR.loadProducts(),
            window.SPR.loadBadges()
          }
          if(theme.review && typeof jdgm !== 'undefined' ){
            $('.qv-product-rv').html(`<div class='pt-1 small' >${jdmgReview}</div>`);
            return jdgm.customizeBadges();
          }
        }
        renderReview();
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        $('.qv-view-product').attr('href', url);
        $('.qv-view-product').click(function(){
          window.location.href = url;
        });
        $('.qv-view-type').text(type);
        $('.qv-view-vendor').text(vendor);
        if ($('.qv-product-description').is(':empty')){
          $('.qv-product-description').removeClass('mb-1');
        }
        else{
          $('.qv-product-description').addClass('mb-1');
        }
        if(quickviewAvaible == 'true'){
          $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        }
        else{
          $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
        }
        $(product.variants).each(function(i,variants) {
          if(variants.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(product.variants[0].sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          
        });
        var imageCount = $(images).length;
        $(images).each(function(i, image) {
          image_embed = '<div><img class="lazyload " role="presentation"  data-src="' + image+"&width=800" + '" srcset="' + image+"&width=800" + '" src="' + image+"&width=800" + '" ></div>';
          $(quickviewThumb).append(image_embed);
        });
        $(quickviewThumb).slick({
          rtl:theme.rtl,
          'dots': true,
          'arrows': true,
          'respondTo': 'min',
          'useTransform': true
        }).css('opacity', '1');
  
        if (product.variants[0].option1 !== "Default Title"){
          $(options).each(function(i, option) {
            var name = option.name;
            var opt = name.replace(/ /g, '-').toLowerCase();
            var selectClass = '.option.' + opt;
            $('.qv-product-options').append('<div class="option-selection ' + opt + '"><span class="option text-body  ">' + option.name + ' :<span class="pl-2 txt-body-70 js-option-label-'+i+' ">'+option.values[0]+'</span></span><select class="option-' + i + ' option ' + opt + '"></select></div>').addClass('pb-3');
            $(option.values).each(function(i, value) {
              $('.option.' + opt).append($('<option>', {
                value: value,
                text: value
              }));
            });
            //list
            if ($("#jsQuickview").data('type') == 'list') {
              var str = '<div class="single-option-radio js-option-' + i + ' ">';
              if (option.name == 'Color') {
                var k = i + 1;
              }
              
              //option.values = option.values.sort();
              $(option.values).each(function(i, value) {
                var cl="";
                if (i == 0){
                  cl="active";
                }
                if (option.name == 'Color') {
                  var variant_img = '';
                  for (cc = 0; cc < variants.length; cc++) { 
                    if (variants[cc]['option'+k] == value) {
                      if (variants[cc]['featured_image'] && variants[cc]['featured_image']['src']) {
                        variant_img = variants[cc]['featured_image']['src'];
                      }
                    }
                  }
                  
                  if (variant_img == '') {
                    str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                  } else {
                    if(qv_color){
                      var file = variant_img;
                      var nvl = value.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
                      const escapedValue = nvl;
                      file = file.slice(0, file.lastIndexOf("/products"));
                      str += `<label class="have-background st-color-${escapedValue} ${cl}" data-value="${value}" style="background-color:${value};"><span class="st-color-${escapedValue} st-color"></span><span>${value}</span></label>`;

                    }
                    else{
                      str += '<label class="have-background '+cl+'" data-value="'+value+'" style="background-image:url('+variant_img+')">'+value+'</label>';	
                    }                  
                     
                  }
                  
                } else{
                  str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                }
                
              });
              str += '</div>';
              $(`.option-selection.${opt}`).append(str);
            }
          });
          if ($("#jsQuickview").data('type') == 'list') {
            $("#jsQuickview .option-selection label").click(function(){
  
              $(this).closest('.option-selection').find('select').val($(this).data('value'));
              $(this).closest('.option-selection').find('label').removeClass('active');
              $(this).addClass('active');
              
              var arr_option = [];
              $("#jsQuickview").find('select.option').each(function(){
                arr_option.push($(this).val());
              });
              var status = true;
              var variant = '';
              for (i=0; i<variants.length; i++) {
                var status = true;
                for (j=0; j<arr_option.length; j++) {
                  if (arr_option[j] != variants[i]['options'][j]) {
                    status = false;
                  }
                }
                if (variants[i]['available'] == false) {
                    status = false;
                }
                if (status == true) {
                  variant = variants[i];
                }
              }
              //console.log(variant);
              //console.log(variant['available']);
              if (variant != '' || variant['available']) {
                $(".qv-add-button").prop( "disabled", false );
                
              } else {
                $(".qv-add-button").prop("disabled", true).html(theme.strings.unavailable);
              }
              
              
              var selectedOptions = '';
              $(quickviewOption).each(function(i) {
                if (selectedOptions == '') {
                  selectedOptions = $(this).val();
                } else {
                  selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
              });
              var targetVl = $(this).data("value");
              for (i=0; i<variants.length; i++) {
                $(this).closest('.option-selection').find('.js-option-label-'+i+'').text(targetVl);
              }
              
              jQuery.getJSON(`/products/${product_handle}.js`, function(product) {
                $(product.variants).each(function(i, v) {
                  if (v.title == selectedOptions) {
                    if (v.featured_image !== null){
                      var iSlick = v.featured_image.position - 1;
                      $(quickviewThumb).slick('slickGoTo', iSlick);
                    }
                    var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
                    var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
                    $(quickviewPrice).html(price);
                    $(quickviewComparePrice).html(compare_price);
                    if (v.compare_at_price !== null) {
                      $(quickviewComparePrice).html(compare_price).show();
                    } else {
                      $(quickviewComparePrice).hide();
                    }
                    //theme.updateCurrencies();
                    
                    if (v) {
                      if (v.available == true) {
                        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
                      }
                      else {
                        $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
                      }
                    }
                    else {
                      $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.unavailable);
                    }
                  }
  
                });
              });
  
            });
          }
        }
        $(product.variants).each(function(i, v) {
          price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          //v.inventory_quantity == 0 && v.inventory_management == 'shopify'
          if (v.inventory_quantity == 0 && v.inventory_management == 'shopify') {
            $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            return true
          } else {
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
       
      }).fail(function() {
    }).always(function() {
        $(quickviewButtonClass+`[data-handle=${product_handle}]`).removeClass('qv-loading');
        $(quickLoad).removeClass('activeload');
    });
    //addCartQuickview
  });
  $(quickviewId).on("hidden.bs.modal", function () {
    $(quickviewId).removeClass('loadqvpopup');
    $(quickLoad).removeClass('activeload');
  });
  // 2. Add to cart
  $(document).on('click',quickviewAddCartButton, function(){
    product_handle = $(quickviewId).data('handle');
    var spinner = '<div class="product-card__loading spinner-border d-block" role="status"></div>';
    var qty = $('.qv-quantity').val(),
        selectedOptions = '',
        var_id = '';
    function processCart() {
      $.post({
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: var_id
        },
        dataType: 'json',
        beforeSend: function() {
          $(quickviewAddCartButton).html(spinner);
        }
      })
      .done(function(item) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var styleCart = $('.js-mini-cart').attr("data-cartmini");
        
        if(styleCart != 'true'){
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        }
        
        theme.miniCart.refresh();

        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      })
      .fail(function($xhr) {
        var data = $xhr.responseJSON;
        theme.alert.new('',data.description,3000,'warning');
      }).always(function() {
        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        $(quickviewId).modal('hide');
      });
    }
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      if (product.variants.length === 1){
        var_id = product.variants[0].id;
      }else{
        $(product.variants).each(function(i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
          }
        });
      }
      processCart();
    });
  });
  // 3. Select variants
  $(document).on('change', quickviewOption, function() {
    var selectedOptions = '';
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        
        if (v.title == selectedOptions) {
          if (v.featured_image !== null){
            var iSlick = v.featured_image.position - 1;
            $(quickviewThumb).slick('slickGoTo', iSlick);
          }
          var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          $(quickviewComparePrice).html(compare_price);
          if(v.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(v.sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          if (v.inventory_management === null) {
            $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
          } else {
            if (v.inventory_quantity < 1) {
              $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            } else {
              $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
            }
          }
        }
      });
    });
  });
})()

// Button add to cart (in grid item) — optimistic
theme.addCartButton = (function(){
  var buttonClass = '.js-grid-cart';
  $(document).on('click',buttonClass,function(){
    var $this = $(this);
    var id = $this.data('id');
    $this.addClass('is-loading');

    // Optimistic: bump cart count badge instantly
    var $countEls = $('.js-cart-count');
    var currentCount = parseInt($countEls.first().text(), 10) || 0;
    $countEls.removeClass('is-empty').text(currentCount + 1);

    Shopify.addItem(id,1,function(item){
        var isMiniCartAction = $this.closest('.mini-cart-content').length > 0;
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var styleCart = $('.js-mini-cart').attr("data-cartmini");
        var htmlAlert = '';

        if (!isMiniCartAction && styleCart != 'true') {
          htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        }

        theme.miniCart.refresh();
        if (isMiniCartAction) {
          theme.alert.cartAdded();
        } else if (styleCart != 'true') {
          theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        }
        $this.removeClass('is-loading');
        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    });

  })
})()

theme.miniCartOffers = (function(){
  var offersTrack = '[data-mini-cart-offers]';
  var prevButton = '[data-mini-cart-offers-prev]';
  var nextButton = '[data-mini-cart-offers-next]';

  function getGap(el) {
    var gap = parseFloat(window.getComputedStyle(el).getPropertyValue('--mini-cart-offers-gap'));
    return isNaN(gap) ? 14 : gap;
  }

  function getPerView(el) {
    var attrValue = el ? parseFloat(el.getAttribute('data-mini-cart-offers-per-view')) : NaN;
    var cssValue = el ? parseFloat(window.getComputedStyle(el).getPropertyValue('--mini-cart-offers-per-view')) : NaN;
    var perView = !isNaN(attrValue) && attrValue > 0 ? attrValue : cssValue;

    return isNaN(perView) || perView <= 0 ? 2 : perView;
  }

  function syncButtons(swiper) {
    if (!swiper || !swiper.el) {
      return;
    }

    var $track = $(swiper.el);
    var $shell = $track.closest('.mini-cart-offers-shell');
    var $prev = $shell.find(prevButton);
    var $next = $shell.find(nextButton);
    var isLocked = swiper.isLocked || swiper.slides.length <= 1;

    $prev.toggleClass('is-hidden', isLocked || swiper.isBeginning);
    $next.toggleClass('is-hidden', isLocked || swiper.isEnd);
  }

  function bindSwiper($track) {
    if (!$track.length || typeof Swiper === 'undefined') {
      return null;
    }

    var existingSwiper = $track.data('miniCartOffersSwiper');
    var shell = $track.closest('.mini-cart-offers-shell').get(0);
    var trackEl = $track.get(0);
    var gap = getGap(trackEl);
    var perView = getPerView(trackEl);

    if (existingSwiper && existingSwiper.destroyed !== true) {
      existingSwiper.params.spaceBetween = gap;
      existingSwiper.originalParams.spaceBetween = gap;
      existingSwiper.params.slidesPerView = perView;
      existingSwiper.originalParams.slidesPerView = perView;
      existingSwiper.update();
      syncButtons(existingSwiper);
      return existingSwiper;
    }

    var swiper = new Swiper(trackEl, {
      slidesPerView: perView,
      slidesPerGroup: 1,
      freeMode: false,
      centeredSlides: false,
      spaceBetween: gap,
      speed: 320,
      watchSlidesVisibility: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      observer: false,
      observeParents: false,
      resizeObserver: true,
      grabCursor: false,
      simulateTouch: true,
      allowTouchMove: true,
      nested: true,
      threshold: 5,
      touchReleaseOnEdges: true,
      longSwipesRatio: 0.2,
      longSwipesMs: 150,
      resistanceRatio: 0.85,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: true,
      preventClicks: true,
      preventClicksPropagation: true,
      navigation: {
        nextEl: shell ? shell.querySelector(nextButton) : null,
        prevEl: shell ? shell.querySelector(prevButton) : null
      },
      on: {
        init: syncButtons,
        resize: syncButtons,
        update: syncButtons,
        slideChange: syncButtons,
        reachBeginning: syncButtons,
        reachEnd: syncButtons,
        fromEdge: syncButtons,
        lock: syncButtons,
        unlock: syncButtons
      }
    });

    $track.data('miniCartOffersSwiper', swiper);
    return swiper;
  }

  function init() {
    $(offersTrack).each(function() {
      bindSwiper($(this));
    });
  }

  function refresh() {
    init();
    $(offersTrack).each(function() {
      var swiper = $(this).data('miniCartOffersSwiper');

      if (swiper && swiper.destroyed !== true) {
        var gap = getGap(swiper.el);
        var perView = getPerView(swiper.el);
        swiper.params.spaceBetween = gap;
        swiper.originalParams.spaceBetween = gap;
        swiper.params.slidesPerView = perView;
        swiper.originalParams.slidesPerView = perView;
        swiper.update();
        syncButtons(swiper);
      }
    });
  }

  $(window).on('load resize', refresh);
  $(document).on('click', '.js-toggle-cart', function(){
    setTimeout(refresh, 120);
  });
  $(document).ready(init);

  return{
    init:init,
    refresh:refresh
  }
})()

theme.GiftWrap = (function(){
  var openBox = '.open-gift',
      giftWrap = '.giftwrap'
      addGift    = '.add-gift',
      boxGift = '.boxgift',
      closeBtn = '.close-gift__btn',
      idGift = $(addGift).data('id'),
      cartDraw = $('.mini-cart-content');
  $(document).on('click',openBox,function(){
    $(this).next().addClass('active');
    $(this).closest(cartDraw).addClass('overlay');
  });
  $(document).on('click',closeBtn,function(){
    $(this).closest(boxGift).removeClass('active');
    $(this).closest(cartDraw).removeClass('overlay');
  });
  function addGiftInCart() {
    
    $(document).on('click',addGift,function(e){
      e.preventDefault();
      $(this).addClass('is-loading');
      
      Shopify.addItem(idGift,1,function(item){
        //console.log(item);
          theme.miniCart.refresh();
          setTimeout(function() {
            $(this).removeClass('is-loading');
          },300);
          if(theme.cartpage){
            location.reload();
            $("html, body").animate({ scrollTop: 0 }, "normal");
          }
      });
      
    })
  }
  addGiftInCart();
  function hideGift(id){
    if(id === idGift){
      $(giftWrap).addClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  function checkGift(id){
    if(id === idGift){
      $(giftWrap).removeClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  return{
    
    hideGift:hideGift,
    checkGift: checkGift,
  }
})()

theme.openAddon = (function(){
  var openBlock = '.js-open-addon',
      closeBlock = '.btn-close-addon',
      addonBlock = '.block-addon__box--wrap'
      cartDraw = $('.mini-cart-content');
      $(document).on('click',openBlock,function(){
        $(this).next().addClass('active');
        $(this).closest(cartDraw).addClass('overlay');
      });
      $(document).on('click',closeBlock,function(){
        $(this).closest(addonBlock).removeClass('active');
        $(this).closest(cartDraw).removeClass('overlay');
      });
})()



// MiniCart
theme.miniCart = (function(){
  var miniCart = '.js-mini-cart',
      styleCart = $(miniCart).attr("data-cartmini"),
      cartToggle = '.js-toggle-cart',
      cartCount = '.js-cart-count',
      cartContent = '.js-mini-cart-content',
      cartTotal = '.js-cart-total',
      cartOriginalTotal = '[data-mini-cart-original-total]',
      cartSavedWrap = '[data-mini-cart-saved]',
      cartSavedAmount = '[data-mini-cart-saved-amount]',
      cartSummary = '[data-mini-cart-summary]',
      cartSummaryToggle = '[data-mini-cart-summary-toggle]',
      cartSummaryPanel = '[data-mini-cart-summary-panel]',
      cartDetailOriginalTotal = '[data-mini-cart-detail-original-total]',
      cartDetailMrpDiscount = '[data-mini-cart-detail-mrp-discount]',
      cartDetailCouponDiscount = '[data-mini-cart-detail-coupon-discount]',
      cartDetailGrandTotal = '[data-mini-cart-detail-grand-total]',
      cartBreakdownSaved = '[data-mini-cart-breakdown-saved]',
      cartBreakdownSavedAmount = '[data-mini-cart-breakdown-saved-amount]',
      cartBreakdownSavedPercent = '[data-mini-cart-breakdown-saved-percent]',
      $crosellcart = '.drawer-crossell',
      $cartBottom = '.js-cart-bottom, .cart-coupon-host--mini-cart',
      cartRequest = null,
      summaryPanelTransitionTimer = null,
      scrollLockClass = 'mini-cart-scroll-lock',
      lockedScrollTop = 0,
      emptyCartConfig = $('.mini-cart-content').first(),
      emptyCartAnimation = emptyCartConfig.data('empty-cart-animation') || '',
      emptyCartHeading = emptyCartConfig.data('empty-cart-heading') || 'YOUR BAG IS EMPTY',
      emptyCartMessage = emptyCartConfig.data('empty-cart-message') || theme.strings.cartEmpty,
      emptyCartPrimaryButtonText = emptyCartConfig.data('empty-cart-button-primary-text') || 'SHOP MENS',
      emptyCartPrimaryButtonUrl = emptyCartConfig.data('empty-cart-button-primary-url') || theme.strings.cartCollection,
      emptyCartSecondaryButtonText = emptyCartConfig.data('empty-cart-button-secondary-text') || 'SHOP WOMENS',
      emptyCartSecondaryButtonUrl = emptyCartConfig.data('empty-cart-button-secondary-url') || theme.strings.cartCollection,
      cartLoadingAnimation = emptyCartConfig.data('cart-loading-animation') || '',
      milestoneConfettiAnimation = emptyCartConfig.data('milestone-confetti-animation') || '',
      lottiePlayerScript = emptyCartConfig.data('lottie-player-src') || '',
      confettiHideTimer = null,
      lottiePlayerLoadPromise = null,
      currentCart = null,
      cachedCartLoader = null,
      cachedMilestoneConfetti = null,
      cachedMilestoneElements = null,
      cachedQuickAddBlocks = null,
      cartLoadingDepth = 0,
      cartLoadingShowTimer = null,
      checkoutButtonLoadingDepth = 0,
      pendingMilestoneConfetti = false,
      lastMilestoneComplete = null,
      emptyCartIconHtml = emptyCartAnimation
        ? '<lottie-player class="mini-cart-empty__animation" src="' + emptyCartAnimation + '" background="transparent" speed="1" autoplay loop aria-hidden="true"></lottie-player>'
        : theme.strings.cartIcon,
      primaryButtonHtml = buildEmptyCartButton(emptyCartPrimaryButtonText, emptyCartPrimaryButtonUrl, 'mini-cart-empty__button--primary'),
      secondaryButtonHtml = buildEmptyCartButton(emptyCartSecondaryButtonText, emptyCartSecondaryButtonUrl, 'mini-cart-empty__button--secondary'),
      emptyCartActionsHtml = primaryButtonHtml || secondaryButtonHtml
        ? '<div class="mini-cart-empty__actions">' + primaryButtonHtml + secondaryButtonHtml + '</div>'
        : '',
      emptyCartHTML = '<div class="mini-cart-empty h-100"><div class="mini-cart-empty__content"><div class="iconcart-empty">' + emptyCartIconHtml + '</div><div class="mini-cart-empty__heading">' + escapeHtml(emptyCartHeading) + '</div><div class="mini-cart-empty__body">' + escapeHtmlWithBreaks(emptyCartMessage) + '</div>' + emptyCartActionsHtml + '</div></div>';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeHtmlWithBreaks(value) {
    return escapeHtml(value).replace(/\r?\n/g, '<br>');
  }

  function buildEmptyCartButton(text, url, modifierClass) {
    if (!text) {
      return '';
    }

    return '<a class="btn mini-cart-empty__button ' + modifierClass + '" href="' + escapeHtml(url || theme.strings.cartCollection) + '">' + escapeHtml(text) + '</a>';
  }

  function buildImageUrl(imageUrl) {
    if (!imageUrl) {
      return '';
    }

    return imageUrl.indexOf('?') === -1
      ? imageUrl + '?width=180'
      : imageUrl + '&width=180';
  }

  function hasMountedNode($element) {
    var element = $element && typeof $element.get === 'function' ? $element.get(0) : null;
    return Boolean(element && document.body.contains(element));
  }

  function resolvedPromise(value) {
    return $.Deferred().resolve(value).promise();
  }

  function createCartUpdatedEvent(cart) {
    if (typeof window.CustomEvent === 'function') {
      return new CustomEvent('theme:cart:updated', {
        detail: {
          cart: cart
        }
      });
    }

    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('theme:cart:updated', false, false, {
      cart: cart
    });
    return event;
  }

  function createMiniCartToggledEvent(active) {
    if (typeof window.CustomEvent === 'function') {
      return new CustomEvent('theme:mini-cart:toggled', {
        detail: {
          active: Boolean(active)
        }
      });
    }

    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('theme:mini-cart:toggled', false, false, {
      active: Boolean(active)
    });
    return event;
  }

  function dispatchCartUpdated(cart) {
    if (!cart) {
      return;
    }

    document.dispatchEvent(createCartUpdatedEvent(cart));
  }

  function dispatchMiniCartToggled(active) {
    document.dispatchEvent(createMiniCartToggledEvent(active));
  }

  function scheduleFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(callback);
      return;
    }

    window.setTimeout(callback, 16);
  }

  function ensureLottiePlayerLoaded() {
    if (!lottiePlayerScript) {
      return resolvedPromise();
    }

    if (window.customElements && typeof window.customElements.get === 'function' && window.customElements.get('lottie-player')) {
      return resolvedPromise();
    }

    if (lottiePlayerLoadPromise) {
      return lottiePlayerLoadPromise;
    }

    var existingScript = document.querySelector('script[data-mini-cart-lottie-player]');
    var deferred = $.Deferred();

    function resolveWhenDefined() {
      if (!window.customElements || typeof window.customElements.whenDefined !== 'function') {
        scheduleFrame(function() {
          deferred.resolve();
        });
        return;
      }

      window.customElements.whenDefined('lottie-player')
        .then(function() {
          scheduleFrame(function() {
            deferred.resolve();
          });
        })
        .catch(function() {
          deferred.resolve();
        });
    }

    function handleLoad() {
      if (this && typeof this.setAttribute === 'function') {
        this.setAttribute('data-loaded', 'true');
      }

      resolveWhenDefined();
    }

    function handleError() {
      lottiePlayerLoadPromise = null;
      deferred.reject();
    }

    if (existingScript) {
      if (existingScript.getAttribute('data-loaded') === 'true') {
        resolveWhenDefined();
        lottiePlayerLoadPromise = deferred.promise();
        return lottiePlayerLoadPromise;
      }

      existingScript.addEventListener('load', handleLoad, { once: true });
      existingScript.addEventListener('error', handleError, { once: true });
      lottiePlayerLoadPromise = deferred.promise();
      return lottiePlayerLoadPromise;
    }

    var script = document.createElement('script');
    script.src = lottiePlayerScript;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-mini-cart-lottie-player', 'true');
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    document.head.appendChild(script);

    lottiePlayerLoadPromise = deferred.promise();
    return lottiePlayerLoadPromise;
  }

  function waitForConfettiPlayer(confetti, attempts) {
    if (!confetti || !confetti.player || typeof confetti.player.play === 'function') {
      return resolvedPromise(confetti);
    }

    if ((attempts || 0) <= 0) {
      return $.Deferred().reject().promise();
    }

    var deferred = $.Deferred();

    scheduleFrame(function() {
      waitForConfettiPlayer(confetti, (attempts || 0) - 1)
        .done(function(nextConfetti) {
          deferred.resolve(nextConfetti);
        })
        .fail(function() {
          deferred.reject();
        });
    });

    return deferred.promise();
  }

  function getMilestoneConfetti() {
    if (!cachedMilestoneConfetti || !hasMountedNode(cachedMilestoneConfetti.$overlay)) {
      var $overlay = getMiniCartContent().find('[data-mini-cart-confetti]').first();

      if (!$overlay.length) {
        $overlay = $('[data-mini-cart-confetti]').first();
      }

      cachedMilestoneConfetti = {
        $overlay: $overlay,
        player: $overlay.find('lottie-player').get(0)
      };
    }

    return cachedMilestoneConfetti;
  }

  function getMiniCartContainer(preferActive) {
    var $activeCart = preferActive === false ? $() : $(miniCart + '.active').first();

    if ($activeCart.length) {
      return $activeCart;
    }

    return $(miniCart).first();
  }

  function getMiniCartContent(preferActive) {
    var $content = getMiniCartContainer(preferActive).find('.mini-cart-content').first();

    if ($content.length) {
      return $content;
    }

    return $('.mini-cart-content').first();
  }

  function getCartLoader() {
    if (!cachedCartLoader || !hasMountedNode(cachedCartLoader.$overlay)) {
      var $overlay = getMiniCartContent().find('[data-mini-cart-loader]').first();

      if (!$overlay.length) {
        $overlay = $('[data-mini-cart-loader]').first();
      }

      cachedCartLoader = {
        $overlay: $overlay,
        player: $overlay.find('lottie-player').get(0)
      };
    }

    return cachedCartLoader;
  }

  function getMilestoneElements() {
    if (!cachedMilestoneElements || !hasMountedNode(cachedMilestoneElements.$milestone)) {
      var $milestone = getMiniCartContent().find('[data-mini-cart-milestone]').first();

      if (!$milestone.length) {
        $milestone = $('[data-mini-cart-milestone]').first();
      }

      cachedMilestoneElements = {
        $milestone: $milestone,
        $text: $milestone.find('[data-mini-cart-milestone-text]'),
        $progress: $milestone.find('[data-mini-cart-milestone-progress]')
      };
    }

    return cachedMilestoneElements;
  }

  function getQuickAddBlocks() {
    if (!cachedQuickAddBlocks || !hasMountedNode(cachedQuickAddBlocks.first())) {
      cachedQuickAddBlocks = $('.mini-cart-quick-add[data-quick-add-product-id]');
    }

    return cachedQuickAddBlocks;
  }

  function getCheckoutButtons() {
    var $buttons = getMiniCartContainer().find('.js-cart-btn-checkout');

    if ($buttons.length) {
      return $buttons;
    }

    return $(miniCart).find('.js-cart-btn-checkout');
  }

  function syncCheckoutButtonLoading(isLoading) {
    var $buttons = getCheckoutButtons();

    if (!$buttons.length) {
      return;
    }

    $buttons.toggleClass('is-cart-loading', isLoading).attr('aria-busy', isLoading ? 'true' : 'false');
  }

  function beginCheckoutButtonLoading() {
    checkoutButtonLoadingDepth += 1;
    syncCheckoutButtonLoading(true);
  }

  function endCheckoutButtonLoading(force) {
    if (force === true) {
      checkoutButtonLoadingDepth = 0;
    } else {
      checkoutButtonLoadingDepth = Math.max(checkoutButtonLoadingDepth - 1, 0);
    }

    if (checkoutButtonLoadingDepth > 0) {
      return;
    }

    syncCheckoutButtonLoading(false);
  }

  function syncCartLoadingUi(isLoading, $cart) {
    var $targetCart = $cart && $cart.length ? $cart : getMiniCartContent();

    $targetCart.toggleClass('is-loading', isLoading).attr('aria-busy', isLoading ? 'true' : 'false');
    syncCheckoutButtonLoading(isLoading);
  }

  function beginCartLoading() {
    cartLoadingDepth += 1;

    if ($(miniCart + '.active').length === 0) {
      return;
    }

    if (cartLoadingShowTimer) {
      return;
    }

    cartLoadingShowTimer = window.setTimeout(function() {
      cartLoadingShowTimer = null;

      if (cartLoadingDepth <= 0 || $(miniCart + '.active').length === 0) {
        return;
      }

      syncCartLoadingUi(true);
    }, 70);
  }

  function endCartLoading(force) {
    if (force === true) {
      cartLoadingDepth = 0;
    } else {
      cartLoadingDepth = Math.max(cartLoadingDepth - 1, 0);
    }

    if (cartLoadingDepth > 0) {
      return;
    }

    window.clearTimeout(cartLoadingShowTimer);
    cartLoadingShowTimer = null;
    syncCartLoadingUi(false);
  }

  function stopMilestoneConfetti() {
    var confetti = getMilestoneConfetti();

    window.clearTimeout(confettiHideTimer);
    confettiHideTimer = null;
    pendingMilestoneConfetti = false;

    if (confetti.player && typeof confetti.player.stop === 'function') {
      confetti.player.stop();
    }

    confetti.$overlay.removeClass('is-active');
  }

  function playMilestoneConfetti() {
    if (!milestoneConfettiAnimation) {
      return;
    }

    if ($(miniCart + '.active').length === 0) {
      pendingMilestoneConfetti = true;
      return;
    }

    pendingMilestoneConfetti = false;

    ensureLottiePlayerLoaded().done(function() {
      var confetti = getMilestoneConfetti();

      if ($(miniCart + '.active').length === 0 || !confetti.$overlay.length || !confetti.player) {
        pendingMilestoneConfetti = true;
        return;
      }

      waitForConfettiPlayer(confetti, 12).done(function(readyConfetti) {
        if ($(miniCart + '.active').length === 0 || !readyConfetti.$overlay.length || !readyConfetti.player) {
          pendingMilestoneConfetti = true;
          return;
        }

        window.clearTimeout(confettiHideTimer);
        readyConfetti.$overlay.addClass('is-active');

        if (typeof readyConfetti.player.stop === 'function') {
          readyConfetti.player.stop();
        }

        if (typeof readyConfetti.player.seek === 'function') {
          try {
            readyConfetti.player.seek(0);
          } catch (error) {}
        }

        window.setTimeout(function() {
          if (typeof readyConfetti.player.play === 'function') {
            readyConfetti.player.play();
          }
        }, 0);

        confettiHideTimer = window.setTimeout(function() {
          stopMilestoneConfetti();
        }, 4200);
      });
    });
  }

  function normalizePropertyValue(value) {
    var stringValue = String(value == null ? '' : value);

    if (stringValue.indexOf('/uploads/') !== -1) {
      return stringValue.split('/').pop();
    }

    return stringValue;
  }

  function getVariantMarkup(product) {
    if (!product.variant_title || product.variant_title === 'Default Title') {
      return '';
    }

    return '<p class="mini-cart-item__variant">' + escapeHtml(product.variant_title) + '</p>';
  }

  function getPropertiesMarkup(product) {
    if (!product.properties) {
      return '';
    }

    var keys = Object.keys(product.properties).filter(function(key) {
      var value = product.properties[key];
      return key.charAt(0) !== '_' && value !== '' && value != null;
    });

    if (!keys.length) {
      return '';
    }

    return '<div class="mini-cart-item__properties">' + keys.map(function(key) {
      return '<span>' + escapeHtml(key) + ': ' + escapeHtml(normalizePropertyValue(product.properties[key])) + '</span>';
    }).join('') + '</div>';
  }

  function getDiscountsMarkup(product) {
    if (!product.discounts || !product.discounts.length) {
      return '';
    }

    return product.discounts.map(function(discount) {
      return '<p class="mini-cart-item__discount">' + escapeHtml(discount.title) + '</p>';
    }).join('');
  }

  function getMilestoneTiers() {
    var script = document.querySelector('script[data-milestone-tiers]');
    if (!script) {
      return [];
    }

    try {
      var tiers = JSON.parse(script.textContent);
      return tiers
        .filter(function(t) { return t.value > 0; })
        .sort(function(a, b) { return a.value - b.value; });
    } catch (e) {
      return [];
    }
  }

  function buildMilestoneMarkerHtml(tier, isReached, isNext) {
    var iconUrl = isReached ? tier.unlockedIcon : tier.lockedIcon;
    var label = tier.label || '';
    var goalText = Shopify.formatMoney(tier.value, theme.moneyFormat);
    var iconHtml = iconUrl
      ? '<img class="mini-cart-milestone__marker-img" src="' + iconUrl + '" alt="" loading="lazy">'
      : '';

    return '<div class="mini-cart-milestone__marker' + (isReached ? ' is-reached' : '') + (isNext ? ' is-next' : '') + '">'
      + '<span class="mini-cart-milestone__marker-icon">' + iconHtml + '</span>'
      + '<span class="mini-cart-milestone__marker-label">' + label + '</span>'
      + '<span class="mini-cart-milestone__marker-goal">' + goalText + '</span>'
      + '</div>';
  }

  function updateMilestone(cart) {
    var milestone = getMilestoneElements();
    var $milestone = milestone.$milestone;

    if (!$milestone.length) {
      lastMilestoneComplete = false;
      stopMilestoneConfetti();
      return;
    }

    var tiers = getMilestoneTiers();

    if (!cart || Number(cart.item_count || 0) === 0 || tiers.length === 0) {
      lastMilestoneComplete = false;
      stopMilestoneConfetti();
      $milestone.removeClass('is-complete');
      $milestone.hide();
      return;
    }

    // Use original (pre-discount) prices so milestones reflect the real cart value
    var qualifyingTotal = 0;
    if (Array.isArray(cart.items) && cart.items.length > 0) {
      for (var q = 0; q < cart.items.length; q++) {
        var mi = cart.items[q];
        qualifyingTotal += Number(mi.original_line_price || mi.line_price || (mi.price || 0) * (mi.quantity || 1));
      }
    } else {
      qualifyingTotal = Number(cart.original_total_price || cart.items_subtotal_price || cart.total_price || 0);
    }
    var maxThreshold = tiers[tiers.length - 1].value;
    var progress = Math.max(0, Math.min(qualifyingTotal / maxThreshold * 100, 100));
    var wasComplete = lastMilestoneComplete;

    if (wasComplete == null) {
      wasComplete = $milestone.hasClass('is-complete');
    }

    var currentTier = null;
    var nextTier = null;
    var allReached = qualifyingTotal >= maxThreshold;

    for (var i = 0; i < tiers.length; i++) {
      if (qualifyingTotal >= tiers[i].value) {
        currentTier = tiers[i];
      } else {
        if (!nextTier) {
          nextTier = tiers[i];
        }
      }
    }

    var statusText = '';
    if (allReached) {
      statusText = currentTier.successText || 'All rewards unlocked!';
    } else if (nextTier) {
      var remaining = nextTier.value - qualifyingTotal;
      statusText = (nextTier.pendingText || 'Add more to unlock') + ' ' + Shopify.formatMoney(remaining, theme.moneyFormat);
    }

    milestone.$text.text(statusText);
    milestone.$progress.css('width', progress + '%');

    var markersContainer = $milestone.find('[data-mini-cart-milestone-markers]');
    if (markersContainer.length) {
      var markersHtml = '';
      // Find the first unreached tier — that's the "next" milestone to animate
      var firstUnreachedIndex = -1;
      for (var k = 0; k < tiers.length; k++) {
        if (qualifyingTotal < tiers[k].value) { firstUnreachedIndex = k; break; }
      }
      for (var j = 0; j < tiers.length; j++) {
        var tierReached = qualifyingTotal >= tiers[j].value;
        var tierIsNext = (j === firstUnreachedIndex);
        var position = (tiers[j].value / maxThreshold) * 100;
        markersHtml += '<div class="mini-cart-milestone__marker-wrap" style="left: ' + Math.min(position, 100) + '%;">'
          + buildMilestoneMarkerHtml(tiers[j], tierReached, tierIsNext)
          + '</div>';
      }
      markersContainer.html(markersHtml);
    }

    $milestone.toggleClass('is-complete', allReached);
    $milestone.show();
    lastMilestoneComplete = allReached;

    if (allReached && !wasComplete) {
      // Confetti disabled on milestone — only fires on explicit coupon apply
      return;
    }

    if (!allReached) {
      stopMilestoneConfetti();
    }
  }

  function updateQuickAddVisibility(cart) {
    var $quickAdd = getQuickAddBlocks();

    if (!$quickAdd.length) {
      return;
    }

    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var isEmptyCart = !cart || Number(cart.item_count || 0) === 0;

    $quickAdd.each(function() {
      var $this = $(this);
      var quickAddProductId = String($this.data('quick-add-product-id') || '');
      var isInCart = items.some(function(item) {
        return String(item.product_id || '') === quickAddProductId;
      });
      var shouldHide = isEmptyCart || isInCart;

      $this.toggleClass('is-hidden', shouldHide);
      $this.css('display', shouldHide ? 'none' : 'grid');
    });
  }

  function updateSummary(cart) {
    var totalPrice = Number(cart && cart.total_price || 0);
    var originalTotal = Number(cart && cart.original_total_price || 0);
    var savedAmount = 0;
    var savedPercent = 0;

    if (originalTotal < totalPrice) {
      originalTotal = totalPrice;
    }

    savedAmount = Math.max(originalTotal - totalPrice, 0);
    savedPercent = originalTotal > 0 && savedAmount > 0
      ? Math.round(savedAmount * 100 / originalTotal)
      : 0;

    $(cartTotal).html(theme.Currency.formatMoney(totalPrice, theme.moneyFormat));
    $(cartOriginalTotal)
      .text(theme.Currency.formatMoney(originalTotal, theme.moneyFormat))
      .toggleClass('is-hidden', savedAmount <= 0);
    $(cartSavedWrap).toggleClass('is-hidden', savedAmount <= 0);
    $(cartSavedAmount).text(theme.Currency.formatMoney(savedAmount, theme.moneyFormat));
    $(cartDetailOriginalTotal).text(theme.Currency.formatMoney(originalTotal, theme.moneyFormat));
    $(cartDetailMrpDiscount).text(theme.Currency.formatMoney(0, theme.moneyFormat));
    $(cartDetailCouponDiscount).text(theme.Currency.formatMoney(savedAmount, theme.moneyFormat));
    $(cartDetailGrandTotal).text(theme.Currency.formatMoney(totalPrice, theme.moneyFormat));
    $(cartBreakdownSaved).toggleClass('is-hidden', savedAmount <= 0);
    $(cartBreakdownSavedAmount).text(theme.Currency.formatMoney(savedAmount, theme.moneyFormat));
    $(cartBreakdownSavedPercent).text(savedPercent);
    refreshSummaryPanelHeight();
  }

  function clearSummaryPanelTransition($panel) {
    window.clearTimeout(summaryPanelTransitionTimer);
    summaryPanelTransitionTimer = null;
    $panel.off('transitionend.miniCartSummary');
  }

  function finalizeSummaryPanel($panel, isExpanded) {
    clearSummaryPanelTransition($panel);

    if (isExpanded) {
      $panel
        .addClass('is-visible')
        .removeClass('is-animating')
        .prop('hidden', false)
        .css('maxHeight', 'none');
      return;
    }

    $panel
      .removeClass('is-animating is-visible')
      .prop('hidden', true)
      .css('maxHeight', '');
  }

  function refreshSummaryPanelHeight() {
    var $panel = $(cartSummaryPanel);

    if (!$panel.length || $panel.prop('hidden')) {
      return;
    }

    if ($panel.hasClass('is-animating')) {
      $panel.css('maxHeight', $panel.get(0).scrollHeight + 'px');
      return;
    }

    if ($panel.hasClass('is-visible')) {
      $panel.css('maxHeight', 'none');
    }
  }

  function setSummaryExpanded(isExpanded) {
    var $summary = $(cartSummary);
    var $toggle = $(cartSummaryToggle);
    var $panel = $(cartSummaryPanel);
    var panel = $panel.get(0);
    var currentHeight = 0;
    var targetHeight = 0;

    $summary.toggleClass('is-open', isExpanded);
    $toggle.attr('aria-expanded', isExpanded ? 'true' : 'false');

    if (!$panel.length || !panel) {
      return;
    }

    clearSummaryPanelTransition($panel);
    $panel.prop('hidden', false).addClass('is-animating');

    currentHeight = panel.getBoundingClientRect().height || 0;

    if (isExpanded) {
      $panel.css('maxHeight', currentHeight + 'px');
      panel.offsetHeight;

      targetHeight = panel.scrollHeight;
      $panel.addClass('is-visible').css('maxHeight', targetHeight + 'px');
    } else {
      currentHeight = currentHeight || panel.scrollHeight;
      $panel.css('maxHeight', currentHeight + 'px');
      panel.offsetHeight;

      $panel.removeClass('is-visible').css('maxHeight', '0px');
    }

    $panel.on('transitionend.miniCartSummary', function(event) {
      if (event.originalEvent && event.originalEvent.propertyName !== 'max-height') {
        return;
      }

      finalizeSummaryPanel($panel, isExpanded);
    });

    summaryPanelTransitionTimer = window.setTimeout(function() {
      finalizeSummaryPanel($panel, isExpanded);
    }, 420);
  }

  function lockBackgroundScroll() {
    var $body = $('body');
    var $html = $('html');

    if ($body.hasClass(scrollLockClass)) {
      return;
    }

    lockedScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    $html.addClass(scrollLockClass);
    $body.addClass(scrollLockClass).css({
      position: 'fixed',
      top: (-lockedScrollTop) + 'px',
      left: '0',
      right: '0',
      width: '100%'
    });
  }

  function unlockBackgroundScroll() {
    var $body = $('body');
    var $html = $('html');

    if (!$body.hasClass(scrollLockClass)) {
      return;
    }

    $html.removeClass(scrollLockClass);
    $body.removeClass(scrollLockClass).css({
      position: '',
      top: '',
      left: '',
      right: '',
      width: ''
    });

    window.scrollTo(0, lockedScrollTop);
  }

  // Track whether mini-cart pushed a history state
  var miniCartHistoryPushed = false;

  function setCartActive($cart, isActive, fromPopstate) {
    var $cartContent = $cart.find('.mini-cart-content').first();

    $cart.toggleClass('active', isActive);
    dispatchMiniCartToggled(isActive);

    if (isActive) {
      ensureLottiePlayerLoaded();
      lockBackgroundScroll();

      // Milestone confetti disabled — only fires on explicit coupon apply
      pendingMilestoneConfetti = false;

      // Push history state so phone back button closes cart instead of navigating away
      if (!miniCartHistoryPushed) {
        miniCartHistoryPushed = true;
        history.pushState({ vayronMiniCart: true }, '');
      }

      return;
    }

    // If we pushed a history state, go back to clean it up
    // (skip if this close was triggered by popstate — back already happened)
    if (miniCartHistoryPushed && !fromPopstate) {
      miniCartHistoryPushed = false;
      try { history.back(); } catch (e) {}
    }

    syncCartLoadingUi(false, $cartContent);
    syncCheckoutButtonLoading(false);
    stopMilestoneConfetti();

    if ($(miniCart + '.active').length === 0) {
      unlockBackgroundScroll();
    }
  }

  function syncCartUi(cart) {
    var isEmptyCart = cart.item_count === 0;

    if (isEmptyCart) {
      $(cartContent).html(emptyCartHTML);
      $(`${$cartBottom}, ${$crosellcart}`).hide();
      if (styleCart === 'true') {
        setCartActive($(miniCart), false);
      }
    } else {
      $(`${$cartBottom}, ${$crosellcart}`).show();
    }

    $(cartCount).toggleClass('is-empty', isEmptyCart).text(isEmptyCart ? '' : cart.item_count);
    updateSummary(cart);
    updateMilestone(cart);
    updateQuickAddVisibility(cart);
    theme.freeShipping.load(cart);
  }

  function getCartData() {
    if (cartRequest) {
      return cartRequest;
    }

    cartRequest = $.getJSON('/cart.js')
      .done(function(cart) {
        currentCart = cart;
      })
      .always(function() {
        cartRequest = null;
      });

    return cartRequest;
  }

  function getCurrentCart() {
    return currentCart;
  }

  function renderCartMarkup(cart) {
    var htmlCart = '',
        itemsMarkup = '',
        itemCount = cart.items.length;

    if (cart.item_count === 0) {
      $(cartContent).html(emptyCartHTML);
      syncCartUi(cart);
      return;
    }

    for (let i = 0; i < itemCount; i++) {
      var line = i + 1;
      var product = cart.items[i];
      theme.GiftWrap.hideGift(product.id);
      itemsMarkup += renderCartItem(product, line);
    }

    htmlCart = '<div class="mini-cart-list">' + itemsMarkup + '</div>';

    $(cartContent).html(htmlCart);
    syncCartUi(cart);
  }

  function applyCartState(cart, options) {
    var settings = $.extend({
      render: true,
      openDrawer: false
    }, options);

    if (settings.render) {
      renderCartMarkup(cart);
    } else {
      syncCartUi(cart);
    }

    if (settings.openDrawer && cart.item_count > 0 && styleCart === 'true') {
      setCartActive($(miniCart), true);
    }

    currentCart = cart;
    dispatchCartUpdated(cart);

    if (
      theme.miniCartOffers &&
      typeof theme.miniCartOffers.refresh === 'function' &&
      (settings.openDrawer || $(miniCart + '.active').length > 0)
    ) {
      scheduleFrame(function() {
        if (settings.openDrawer || $(miniCart + '.active').length > 0) {
          theme.miniCartOffers.refresh();
        }
      });
    }
  }

  function refreshCart(cart, options) {
    var settings = $.extend({
      render: true,
      openDrawer: false
    }, options);
    var shouldShowLoader = !cart && (settings.openDrawer || $(miniCart + '.active').length > 0);

    if (cart && typeof cart.item_count !== 'undefined') {
      applyCartState(cart, settings);
      return $.Deferred().resolve(cart).promise();
    }

    if (shouldShowLoader) {
      beginCartLoading();
    }

    return getCartData().done(function(fetchedCart) {
      applyCartState(fetchedCart, settings);
    }).always(function() {
      if (shouldShowLoader) {
        endCartLoading();
      }
    });
  }

  function renderCartItem(product, line) {
    var productTitle = product.product_title || product.title || '';
    var productUrl = escapeHtml(product.url || '/cart');
    var imageUrl = buildImageUrl(product.image);
    // Use != null checks so a legitimate 0 (BXGY free item) isn't mistaken for missing
    var finalLinePrice = product.final_line_price != null
      ? product.final_line_price
      : (product.line_price != null
          ? product.line_price
          : (product.final_price || product.price || 0) * (product.quantity || 1));
    var originalLinePrice = product.original_line_price != null
      ? product.original_line_price
      : (product.line_price != null
          ? product.line_price
          : (product.price || 0) * (product.quantity || 1));
    var linePrice = finalLinePrice === 0
      ? '<span class="mini-cart-item__free">FREE</span>'
      : theme.Currency.formatMoney(finalLinePrice, theme.moneyFormat);
    var comparePrice = originalLinePrice > finalLinePrice
      ? theme.Currency.formatMoney(originalLinePrice, theme.moneyFormat)
      : '';

    return ''
      + '<div class="mini-cart-item">'
      +   '<a class="mini-cart-image" href="' + productUrl + '">'
      +     (imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(productTitle) + '" loading="lazy">' : '')
      +   '</a>'
      +   '<div class="mini-cart-meta">'
      +     '<a class="mini-cart-item__title" href="' + productUrl + '">' + escapeHtml(productTitle) + '</a>'
      +     '<div class="mini-cart-item__price-block">'
      +       '<span class="mini-cart-item__price">' + linePrice + '</span>'
      +       (comparePrice ? '<s class="mini-cart-item__compare">' + comparePrice + '</s>' : '')
      +     '</div>'
      +     getVariantMarkup(product)
      +     getPropertiesMarkup(product)
      +     '<div class="mini-cart-item__actions">'
      +       '<button class="mini-cart-remove js-remove-mini-cart" type="button" data-id="' + product.id + '" data-line="' + line + '" aria-label="Remove ' + escapeHtml(productTitle) + '">'
      +         '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6 2h4l.35 1H13a.75.75 0 0 1 0 1.5h-.4l-.45 7.07A1.5 1.5 0 0 1 10.65 13H5.35a1.5 1.5 0 0 1-1.5-1.43L3.4 4.5H3a.75.75 0 0 1 0-1.5h2.65L6 2Zm-.65 2.5.43 6.98h4.44l.43-6.98H5.35ZM6.75 6a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 6.75 6Zm2.5 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 9.25 6Z" fill="currentColor"></path></svg>'
      +       '</button>'
      +       '<div class="mini-cart-qty">'
      +         '<button type="button" class="js-qty__adjust js-qty__minus" aria-label="Reduce item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 22 3"><path fill="currentColor" d="M21.5.5v2H.5v-2z" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">-</span></button>'
      +         '<input data-line="' + line + '" type="number" min="0" class="change-minicart js-qty__input" pattern="[0-9]*" value="' + product.quantity + '" aria-label="Quantity for ' + escapeHtml(productTitle) + '" readonly tabindex="-1">'
      +         '<button type="button" class="js-qty__adjust js-qty__plus" aria-label="Increase item quantity by one"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 22 21"><path d="M12 11.5h9.5v-2H12V0h-2v9.5H.5v2H10V21h2v-9.5z" fill="currentColor" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">+</span></button>'
      +       '</div>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  // =========================================================================
  // Optimistic UI helpers — update DOM instantly, sync with server in background
  // =========================================================================

  function getItemUnitPrice(item) {
    // Get the per-unit final price (after line discounts)
    // Use != null so 0 (BXGY free item) is treated as a real value, not missing
    if (item.final_price != null) return item.final_price;
    if (item.final_line_price != null && item.quantity > 0) return Math.round(item.final_line_price / item.quantity);
    return item.price || 0;
  }

  function getItemOriginalUnitPrice(item) {
    if (item.original_price != null) return item.original_price;
    if (item.original_line_price != null && item.quantity > 0) return Math.round(item.original_line_price / item.quantity);
    return item.price || 0;
  }

  // Optimistically update a single line item's quantity, price, and totals in the DOM
  function optimisticQuantityUpdate(line, newQty, $item) {
    if (!currentCart || !currentCart.items) return;

    var itemIndex = line - 1;
    var item = currentCart.items[itemIndex];
    if (!item) return;

    var oldQty = item.quantity || 0;
    var qtyDelta = newQty - oldQty;
    if (qtyDelta === 0) return;

    var unitPrice = getItemUnitPrice(item);
    var unitOriginalPrice = getItemOriginalUnitPrice(item);
    var newLinePrice = unitPrice * newQty;
    var newOriginalLinePrice = unitOriginalPrice * newQty;

    // Update the line price in DOM
    var $priceEl = $item.find('.mini-cart-item__price');
    if ($priceEl.length) {
      $priceEl.html(theme.Currency.formatMoney(newLinePrice, theme.moneyFormat));
    }

    // Update compare price
    var $compareEl = $item.find('.mini-cart-item__compare');
    if (newOriginalLinePrice > newLinePrice) {
      if ($compareEl.length) {
        $compareEl.html(theme.Currency.formatMoney(newOriginalLinePrice, theme.moneyFormat));
      }
    } else {
      $compareEl.remove();
    }

    // Update cart count badge
    var newItemCount = Math.max((currentCart.item_count || 0) + qtyDelta, 0);
    $(cartCount).toggleClass('is-empty', newItemCount <= 0).text(newItemCount > 0 ? newItemCount : '');

    // Update total price (approximate — server will confirm)
    var priceDelta = unitPrice * qtyDelta;
    var newTotal = Math.max((currentCart.total_price || 0) + priceDelta, 0);
    $(cartTotal).html(theme.Currency.formatMoney(newTotal, theme.moneyFormat));

    // Update "grand total" in summary panel
    $(cartDetailGrandTotal).text(theme.Currency.formatMoney(newTotal, theme.moneyFormat));
  }

  // Optimistically remove an item from the DOM and update totals
  function optimisticRemoveItem(line, $item) {
    if (!currentCart || !currentCart.items) return;

    var itemIndex = line - 1;
    var item = currentCart.items[itemIndex];
    if (!item) return;

    var itemFinalPrice = item.final_line_price || item.line_price || (getItemUnitPrice(item) * (item.quantity || 1));
    var removedQty = item.quantity || 1;

    // Hide the item instantly (no fadeOut delay)
    $item.css({ overflow: 'hidden', transition: 'height 0.15s ease, opacity 0.12s ease', opacity: 0, height: 0, padding: 0, margin: 0 });

    // Update count
    var newItemCount = Math.max((currentCart.item_count || 0) - removedQty, 0);
    $(cartCount).toggleClass('is-empty', newItemCount <= 0).text(newItemCount > 0 ? newItemCount : '');

    // Update total
    var newTotal = Math.max((currentCart.total_price || 0) - itemFinalPrice, 0);
    $(cartTotal).html(theme.Currency.formatMoney(newTotal, theme.moneyFormat));
    $(cartDetailGrandTotal).text(theme.Currency.formatMoney(newTotal, theme.moneyFormat));
  }

  // =========================================================================
  // Server sync with debounce
  // =========================================================================

  var pendingLineUpdate = null;
  var pendingLineTimer = null;

  function updateLineItem(line, quantity) {
    var nextQuantity = Math.max(parseInt(quantity, 10) || 0, 0);

    // Debounce rapid clicks — only send the last value after 250ms of inactivity
    if (pendingLineTimer) {
      window.clearTimeout(pendingLineTimer);
    }

    pendingLineUpdate = { line: line, quantity: nextQuantity };

    pendingLineTimer = window.setTimeout(function() {
      var update = pendingLineUpdate;
      pendingLineUpdate = null;
      pendingLineTimer = null;

      jQuery.post('/cart/change.js', {
        quantity: update.quantity,
        line: update.line
      }, null, 'json').done(function(cart) {
        // Server response — reconcile with optimistic UI
        refreshCart(cart, {
          render: true,
          openDrawer: true
        });
      }).fail(function() {
        // Revert on error — full refresh from server
        refreshCart(null, { render: true, openDrawer: true });
      });
    }, 250);
  }


  function updateElements(cart){
    return refreshCart(cart, {
      render: false,
      openDrawer: true
    });
  }
  function generateCart(cart){
    return refreshCart(cart, {
      render: true,
      openDrawer: false
    });
  }

  function refresh(cart){
    return refreshCart(cart, {
      render: true,
      openDrawer: true
    });
  }

  // Quantity minus — optimistic
  $(document).on('click', cartContent + ' .js-qty__minus', function(){
    var $input = $(this).siblings('.js-qty__input');
    var currentValue = parseInt($input.val(), 10) || 0;
    var nextValue = currentValue > 0 ? currentValue - 1 : 0;
    var line = $input.data('line');

    $input.val(nextValue);

    // Optimistic: update price/total instantly
    var $item = $(this).closest('.mini-cart-item');
    optimisticQuantityUpdate(line, nextValue, $item);

    // If quantity becomes 0, treat as remove
    if (nextValue === 0) {
      optimisticRemoveItem(line, $item);
    }

    updateLineItem(line, nextValue);
  });

  // Quantity plus — optimistic
  $(document).on('click', cartContent + ' .js-qty__plus', function(){
    var $input = $(this).siblings('.js-qty__input');
    var nextValue = (parseInt($input.val(), 10) || 0) + 1;
    var line = $input.data('line');

    $input.val(nextValue);

    // Optimistic: update price/total instantly
    var $item = $(this).closest('.mini-cart-item');
    optimisticQuantityUpdate(line, nextValue, $item);

    updateLineItem(line, nextValue);
  });

  $(document).on('change', cartContent + ' .change-minicart', function(){
    updateLineItem($(this).data('line'), $(this).val());
  });

  $(document).on('click', cartSummaryToggle, function(){
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    setSummaryExpanded(!isExpanded);
  });

  // Remove items — optimistic
  $(document).on('click','.js-remove-mini-cart',function(){
    var itemId = $(this).data('id');
    var line = $(this).data('line');
    var $item = $(this).closest('.mini-cart-item');

    // Optimistic: hide item and update totals instantly
    optimisticRemoveItem(line, $item);

    theme.GiftWrap.checkGift(itemId);
    updateLineItem(line, 0);
  });

  //Keep popup when click cart / UX
  $(document).on('click', cartToggle, function(){
    var $cart = $(this).parent(miniCart);
    setCartActive($cart, !$cart.hasClass('active'));
  });
  $(document).on('click', '.overlaycart, .close', function(){
    setCartActive($(this).closest(miniCart), false);
  });

  // Phone back button — close topmost overlay instead of navigating away
  // Stack order: page → mini-cart → coupon drawer
  // Only mini-cart pushes a history state. Pressing back:
  //   1) If coupon drawer is open → close coupon drawer, re-push history (cart stays)
  //   2) If only cart is open → close cart
  window.addEventListener('popstate', function () {
    if (!miniCartHistoryPushed) return;

    // Check if coupon drawer is on top
    var couponSheet = document.querySelector('[data-cart-coupon-sheet]');
    if (couponSheet && couponSheet.classList.contains('is-open')) {
      // Close only the coupon drawer, keep cart open
      couponSheet.classList.remove('is-open');
      couponSheet.classList.add('is-closing');
      document.body.classList.remove('cart-coupon-sheet-open');
      setTimeout(function () {
        couponSheet.classList.remove('is-closing');
        couponSheet.hidden = true;
        couponSheet.setAttribute('aria-hidden', 'true');
      }, 320);
      // Re-push history state so next back press closes the cart
      history.pushState({ vayronMiniCart: true }, '');
      return;
    }

    // No coupon drawer — close the cart
    miniCartHistoryPushed = false;
    var $activeCart = $(miniCart + '.active');
    if ($activeCart.length > 0) {
      $activeCart.removeClass('active');
      dispatchMiniCartToggled(false);
      syncCartLoadingUi(false, $activeCart.find('.mini-cart-content').first());
      syncCheckoutButtonLoading(false);
      stopMilestoneConfetti();
      unlockBackgroundScroll();
    }
  });

  // gen minicart when load page
  generateCart();
  return{
    updateElements:updateElements,
    generateCart: generateCart,
    refresh: refresh,
    loadCart: getCartData,
    getCurrentCart: getCurrentCart,
    beginLoading: beginCartLoading,
    endLoading: endCartLoading,
    playMilestoneConfetti: playMilestoneConfetti
  }
})()

// Free shipping
theme.freeShipping = (function(){
  var $freeShippingClass = $('.js-free-shipping'),
      $freeShippingTextClass = $('.js-free-shipping-text'),
      $free_fisrt = $freeShippingClass.attr('data-start'),
      $free_end = $freeShippingClass.attr('data-end')
      minOrderValue = parseInt($freeShippingClass.data('value')) || 0,
      $percentClass = $('.js-free-shipping .progress-bar');

  function generate(cart){
    var priceCart = cart.total_price;
    priceCart == 0 ? $freeShippingClass.hide() : $freeShippingClass.show();
    if (priceCart >= minOrderValue){
      $percentClass.css('width','100%').removeClass('progress-bar-striped bg-primary');
      $freeShippingTextClass.text(theme.strings.freeShipping);
      $freeShippingTextClass.prev('svg').removeClass('hide');
    }else{
      let percent = priceCart / minOrderValue * 100;
      let left = Shopify.formatMoney((minOrderValue - priceCart),theme.moneyFormat);
      $percentClass.css('width',percent+'%').addClass('progress-bar-striped primary');
      $freeShippingTextClass.html($free_fisrt +' '+ left +' '+ $free_end);
      $freeShippingTextClass.prev('svg').removeClass('hide');
      //theme.updateCurrencies();
    }
  }

  // Removed: duplicate Shopify.getCart() call.
  // freeShipping.load() is already called by miniCart.syncCartUi() on every cart update.

  return {
    load:generate
  }
})()

// Shipping time - https://github.com/phstc/jquery-dateFormat
theme.shippingTime = (function(){
  var $shippingTime = $('.js-shipping-time'),
      shippingTime = $shippingTime.data('time') || '',
      now = new Date(),
      restHour = 23 - now.getHours(),
      restMinute = 59 - now.getMinutes();
  if (shippingTime !== ''){
    var nextTime = new Date(now.getTime() + shippingTime * 86400000),
        formatTime = $.format.date(nextTime, "ddd, dd MMMM yyyy"),
        htmlShipping = 'Order in the next <b>'+restHour+'</b> hours <b>'+restMinute+'</b> minutes to get it by <b>'+formatTime+'</b>. ';
    $shippingTime.html(htmlShipping);
  }
})()




// Wishlist
theme.wishlist = (function () {
  const btnWishlist = '.js-btn-wishlist',
        btnRemoveWishlist = '.js-remove-wishlist',
        $wishlistCount = $('.js-wishlist-count'),
        $wishlistContainer = $('.js-wishlist-content'),
        wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [],
        wishlistPageUrl = $('.js-wishlist-link').attr('href');

  function showNoResult() {
    $wishlistContainer.html(`
      <div class="col text-center">
        <div class="alert alert-warning d-inline-block">${theme.strings.wishlistNoResult}</div>
      </div>
    `);
  }

  function updateWishlist(self) {
    const productHandle = $(self).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);
    const isAdded = wishlist.includes(productHandle);

    if (isAdded) {
      window.location.href = wishlistPageUrl;
    } else {
      wishlist.push(productHandle);
      allSimilarProducts.fadeOut('slow').fadeIn('fast').html(`${theme.strings.wishlistIconAdded}${theme.strings.wishlistTextAdded}`);
      allSimilarProducts.attr('data-original-title', theme.strings.wishlistTextAdded);
      $('.tooltip-inner').text(theme.strings.wishlistTextAdded);
    }

    localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    $wishlistCount.text(wishlist.length);
  }

  function loadWishlist() {
    $wishlistContainer.empty();

    if (wishlist.length > 0) {
      wishlist.forEach((productHandle) => {
        jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, function(product) {
          const productPrice = product.price_varies
            ? `from ${theme.Currency.formatMoney(product.price_min, theme.moneyFormat)}`
            : theme.Currency.formatMoney(product.price, theme.moneyFormat);
          const productComparePrice = product.compare_at_price_min !== 0
            ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat)
            : '';
          const priceClass = productComparePrice ? 'wl-sale' : '';

          const htmlProduct = `
            <div class="js-wishlist-item col-md-4 col-sm-6 col-xs-6 col-12 mb-4 pb-3">
              <div class="js-wishlist-itembox">
                <div class="d-flex flex-row">
                  <a class="d-inline-block mr-4 wl-left" href="${product.url}">
                    <img class="lazyload" data-src="${product.featured_image}"/>
                  </a>
                  <div>
                    <a href="${product.url}" class="title-product d-block product-card__name mb-1">${product.title}</a>
                    <span class="${priceClass}">${productPrice}</span>
                    <s>${productComparePrice}</s>
                    <p><button class="btn js-remove-wishlist link px-0 small" data-handle="${product.handle}">${theme.strings.wishlistRemove}</button></p>
                  </div>
                </div>
              </div>
            </div>
          `;

          $wishlistContainer.append(htmlProduct);
        });
      });
    } else {
      showNoResult();
    }

    $wishlistCount.text(wishlist.length);

    $(btnWishlist).each(function () {
      const productHandle = $(this).data('handle');
      const isProductAdded = wishlist.includes(productHandle);
      const iconWishlist = isProductAdded ? theme.strings.wishlistIconAdded : theme.strings.wishlistIcon;
      const textWishlist = isProductAdded ? theme.strings.wishlistTextAdded : theme.strings.wishlistText;

      $(this).html(`${iconWishlist}${textWishlist}`).attr('title', textWishlist);
    });
  }

  $(document).on('click', btnWishlist, function (event) {
    event.preventDefault();
    updateWishlist(this);
  });

  $(document).on('click', btnRemoveWishlist, function () {
    const productHandle = $(this).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);

    allSimilarProducts.html(`${theme.strings.wishlistIcon}${theme.strings.wishlistText}`);
    allSimilarProducts.attr('data-original-title', theme.strings.wishlistText);

    const productIndex = wishlist.indexOf(productHandle);
    if (productIndex !== -1) {
      wishlist.splice(productIndex, 1);
      localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    }

    $(this).closest('.js-wishlist-item').fadeOut(() => {
      $(this).remove();
      if (wishlist.length === 0) {
        showNoResult();
      }
    });

    $wishlistCount.text(wishlist.length);
  });

  loadWishlist();
  $(document).on('shopify:section:load', loadWishlist);

  return {
    load: loadWishlist
  };
})();



// Compare
theme.compare = (function (){
  var compareButtonClass = '.js-btn-compare',
      compareRemoveButtonClass = '.js-remove-compare',
      $compareCount = $('.js-compare-count'),
      $compareContainer = $('.js-compare-content'),
      compareObject = JSON.parse(localStorage.getItem('localCompare')) || [],
      alertClass='notice';
  function updateCompare(self) {
    var productHandle = $(self).data('handle'),
        alertText = '';
    var isAdded = $.inArray(productHandle,compareObject) !== -1 ? true:false;
    if (isAdded) {
      compareObject.splice(compareObject.indexOf(productHandle), 1);
      alertText = theme.strings.compareNotifyRemoved;
      alertClass = 'notice';
    }else{
      if (compareObject.length === 4){
        alertText = theme.strings.compareNotifyMaximum;
        alertClass = 'error';
      }else{
        alertClass = 'notice';
        compareObject.push(productHandle);
        alertText = theme.strings.compareNotifyAdded;
      }
    }
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    theme.alert.new(theme.strings.compareText,alertText,2000,alertClass);
    $compareCount.text(compareObject.length);
  };
  function loadCompare(){
    var compareGrid;
    $compareContainer.html('');
    //popup compare
    if (compareObject.length > 0){
      compareGrid = compareObject.length === 1? 'col-md-12 col-sm-6' : 'col';
      for (var i = 0; i < compareObject.length; i++) { 
        var productHandle = compareObject[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '',
              productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat),
              productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '',
              productAvailable = product.available ? theme.strings.available : theme.strings.unavailable,
              productAvailableClass = product.available ? 'alert-success' : 'alert-danger',
              productTypeHTML = product.type !== "" ? '<a class="link" href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme.strings.none +'</span>',
              productVendorHTML = product.vendor !== "" ? '<a class="link" href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme.strings.none +'</span>';
          htmlProduct += '<div class="compare-item '+compareGrid+' col-xs-6 px-0">';
          htmlProduct += '  <p class="py-3"><button class="js-remove-compare link " data-handle="'+product.handle+'">'+ theme.strings.compareTextRemove +'</button></p>';
          htmlProduct += '	<a class="d-block mb-4 px-4" href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ Shopify.resizeImage(product.featured_image,'x230') +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<hr /><h5 >'+ product.title +'</h5>';
          htmlProduct += '	<hr /><s class="small">'+ productComparePrice +'</s>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	<hr /><span class="px-2 py-1 rounded '+ productAvailableClass +'"> '+ productAvailable +'</span>';
          htmlProduct += '	<hr />'+ productTypeHTML;
          htmlProduct += '	<hr /><div class="pb-3">'+ productVendorHTML+'</div>';
          htmlProduct += '</div>';
          $compareContainer.append(htmlProduct);
          //theme.updateCurrencies();
        });
      }
    }else{
      $compareContainer.html('<div class="alert alert-warning d-inline-block mb-0">'+ theme.strings.compareNoResult + '</div>');
    }
    
    //button text
    $(compareButtonClass).each(function(){
      var productHandle = $(this).data('handle');
      var status = $.inArray(productHandle,compareObject) !== -1 ? 'added' : '';
      $(this).removeClass('added').addClass(status);
    });

    //count items
    $compareCount.text(compareObject.length);
  }
  $(document).on('click',compareButtonClass,function (event) {
    event.preventDefault();
    updateCompare(this);
    loadCompare();
  });
  $(document).on('click',compareRemoveButtonClass,function(){
    var productHandle = $(this).data('handle');
    compareObject.splice(compareObject.indexOf(productHandle), 1);
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    loadCompare();
  });

  loadCompare();
  $(document).on('shopify:section:load', loadCompare);
  return{
    load:loadCompare
  }
})()

// Popup newsletter
theme.popupNewletter = (function(){
  function popupNewletter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      popupSection : '.popupnew-' + sectionId,
      formSection : '#jsPopupNewsletter' + sectionId
    }
    this.init();
  }
  popupNewletter.prototype = _.assignIn({}, popupNewletter.prototype, {
    init: function() {
      this.showPopup();
    },
    showPopup: function(){
      var $popupNewsletter = $(this.selectors.formSection),
          $newsletterForm = $(this.selectors.formSection).find("form"),
          date = new Date(),
          minutes = theme.timePopupNewsletter;
          minutesdelay = $popupNewsletter.attr('data-delay');
      if ($popupNewsletter.length === 1){
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        var setCookies = function (){
          $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' } );
        };
        if ($.cookie('cookiesNewsletter') !== "disabled") {
          $(window).on('load',function(){
            setTimeout(function () {
              $popupNewsletter.modal('show');
            }, minutesdelay * 1000);
          });
          $popupNewsletter.on('hidden.bs.modal', setCookies);
          $newsletterForm.submit(setCookies);     
        }
      }
      if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(event){
          $(event.target).find($popupNewsletter).modal('show');
        });
        document.addEventListener('shopify:section:deselect', function(event){
          $(event.target).find($popupNewsletter).modal('hide');
        });
      }
    }
  });
  
  return popupNewletter;
})()


theme.BeforeAfter = (function(){
  function BeforeAfter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bablockSection : '#beer-slider-' + sectionId
    }
    this.init();
  }
  BeforeAfter.prototype = _.assignIn({}, BeforeAfter.prototype, {
    init: function() {
      this.showBeforeAfter();
    },
    showBeforeAfter: function(){
      var $baBlock = $(this.selectors.bablockSection);
      $.fn.BeerSlider = function ( options ) {
        options = options || {};
        return this.each(function() {
          new BeerSlider(this, options);
        });
      };
      $($baBlock).BeerSlider({start: 50});
    }
  });
  
  return BeforeAfter;
})()

// Cookie policy

theme.CookieSection = (function() {
  class CookieSection {
    constructor(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.cookieSelector = '.cookie-' + this.sectionId;
      this.closeButtonSelector = '.js-btn-ok';
      this.declineButton = '.js-btn-decline';
      this.init();
    }

    init() {
      this.showCookie();
    }

    showCookie() {
      const $cookiePolicy = $(this.cookieSelector);
      const $closeButton = $(this.closeButtonSelector);
      const $declineButton = $(this.declineButton);
      const isAccepted = localStorage.getItem('localCookie') || '';

      if (!isAccepted) {
        $cookiePolicy.fadeIn('slow');
      }

      $closeButton.on('click', () => {
        localStorage.setItem('localCookie', 'accept');
        $cookiePolicy.fadeOut('slow');
      });
      $declineButton.on('click', () => {
        $cookiePolicy.fadeOut('slow');
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          $cookiePolicy.fadeOut('slow');
        });

        document.addEventListener('shopify:section:select', event => {
          $(event.target).find($cookiePolicy).fadeIn('fast');
        });

        document.addEventListener('shopify:section:deselect', event => {
          $(event.target).find($cookiePolicy).fadeOut('slow');
        });
      }
    }
  }

  return CookieSection;
})();



// Popup newsletter
theme.FooterSection = (function(){
  function FooterSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var enableAcc = Boolean($container.attr('data-acc'));
    this.selectors = {
      footerSection : '.footer-' + sectionId,
      enableAcc : enableAcc,
    }
    this.init();
  }
  FooterSection.prototype = _.assignIn({}, FooterSection.prototype, {
    init: function() {
      this.accordionResponsive();
    },

    accordionResponsive: function(){

        //var mqr = window.matchMedia('screen and (max-width: 749px)');
        if (this.selectors.enableAcc == true){
          /*var acc = document.getElementsByClassName("site-footer__section-title");
          var i;
          for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
              this.classList.toggle("active");
              var panel = this.nextElementSibling;
              if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
              }
            });
          }
          */
          $('.site-footer__section-title').click(function() {
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
            return false;
          });
        }
    }
  });
  
  return FooterSection;
})()


// Open external link in new tab
theme.exLink = (function(){
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && $(links[i]).attr('href') !== 'javascript:void(0)') {
      links[i].target = '_blank';
    }
  }
})()


// Collection view - Collection page
theme.collectionView =  (function (){
  var btnView = '.js-btn-view',
      btnViewActive = '.js-btn-view.active';

  $(document).on('click',btnView,function(){
    var value = $(this).data('col'),
        $gridItemCol = $('.js-col');

    $(btnView).removeClass('active');
    $(this).addClass('active');

    $gridItemCol.removeClass().addClass('js-col col-sm-6 col-6');
    if (value === 3){
      $gridItemCol.addClass('col-lg-4');
    }else if(value === 4){
      $gridItemCol.addClass('col-lg-3');
    }else if(value === 5){
      $gridItemCol.addClass('col-lg-2-4');
    }else if(value === 6){
      $gridItemCol.addClass('col-lg-2');
    };
  })

  function triggerCollectionView(){
    $(btnViewActive).trigger('click');
  }

  return {
    triggerView:triggerCollectionView
  }
})()

// Swath variant in card item
theme.swatchCard = (function() {
  const $swatches = '.js-swatch-card-item';
  const $image = '.product-card__image img';
  const $cart = '.js-grid-cart';

  function handleSwatchClick() {
    const $swatch = $(this);
    const newImage = $swatch.data('image');
    const id = $swatch.data('id');
    const $card = $swatch.closest('.js-product-card');

    $card.find($swatches).removeClass('active');
    $swatch.addClass('active');

    $card.find($image).attr('srcset', newImage);
    $card.find($cart).data('id', id);
  }

  $(document).on('click', $swatches, handleSwatchClick);
})();




theme.swatchCard2 = (function(){
  function initVariant(id){
    var productJson = JSON.parse($('.customJson-' + id).html());
    var $selectorForm = $('.customform-' + id);
    var $button = $('.js-customform-addtocart-' + id);
    var $buttontext = $button.find('span');
    var $wrapObject = $selectorForm.closest('.js-product-card');
    var options = {
      $container: $selectorForm,
      enableHistoryState: false,
      product: productJson,
      singleOptionSelector: '.single-option-selector-' + id,
      originalSelectorId: '#ProductSelect-' + id
    };
    var variants = new slate.Variants(options);
    var AjaxCart = new window.AjaxCart($selectorForm);
    var _updateButton = function (evt){
      var variant = evt.variant;
      if (variant === undefined){
        $button.prop('disabled', true).removeClass('btn--sold-out');
        $buttontext.html(theme.strings.unavailable);
      }else{
        if (variant.available){
          $button.removeClass('btn--sold-out').prop('disabled', false);
          $buttontext.html(theme.strings.addToCart);
        }else{
          $button.prop('disabled', true).addClass('btn--sold-out');
          $buttontext.html(theme.strings.soldOut);
        }
      }
    }
    var _updateImage = function (evt){
      var variant = evt.variant;
      var $mainImage = $wrapObject.find('.product-card__image').find('img');
      if (variant !== undefined && variant.featured_image !== null){
        var variantImage = variant.featured_image;
        $mainImage.attr('srcset',variantImage.src);
      }
    }
    var _updatePrice = function (evt){
      var $price = $wrapObject.find('.product-card__price');
      var variant = evt.variant;
      if (variant !== undefined){
        var htmlComparePrice = variant.compare_at_price !== null ? '<s class="product-card__regular-price"><span class="money">'+variant.compare_at_price+'</span></s>' : '';
        var htmlPrice = '<span class="money">'+variant.price+'</span>' + htmlComparePrice ;
        $price.html(htmlPrice);
        //theme.updateCurrencies();
      }
    }
    variants.$container.on(
      'variantChange' , _updateButton
    );
    variants.$container.on(
      'variantChange' , _updateImage
    );
    variants.$container.on(
      'variantChange' , _updatePrice
    );
  }
  function initForm(){
    $('.js-customform').each(function(){
      var id = $(this).data('id');
      initVariant(id);
    })
  }

  initForm();
  return{
    load:initForm
  }
})()

// Loading
theme.loading = (function(){
  var $loading = $('#js-loading'),
      hasLoading = $('#js-loading').length === 0? false : true;
  if (hasLoading){
    $(window).load(function () {
      $loading.fadeOut();
    });  
  }
})()

theme.effectLeavingPage = (function(){
  window.onbeforeunload = function(){
    $('body').css('opacity','0');
  }
})()





theme.bundleProduct = (function(){
  function bundleProduct(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bundleSection : '#bundle-' + sectionId
    }
    this.init();
  }
  bundleProduct.prototype = _.assignIn({}, bundleProduct.prototype, {
    init: function() {
      this.bundleList();
    },
    bundleList : function(){
      let variantSelectClass = '.fbtproduct-form__variants',
      parentClass = '.fbt-item',
      totalPrice = '.fpt-total',
      totalPriceCompare = '.fpt-totalcompare',
      totalSave = '.fpt-save',
      checkBox = '.fbt-checkbox';

        updateTotal();
        checkItem();
        
        // change update variant
        $(document).on('change',variantSelectClass,function(){
          var selectVariant = $(this).children(':selected'),
              selectVariantId = selectVariant.data('id'),
              newPrice = theme.Currency.formatMoney(selectVariant.data('price'), theme.moneyFormat);
              newPriceCompare = theme.Currency.formatMoney(selectVariant.data('price-compare'), theme.moneyFormat);
              
          if (selectVariant.data('image') !== ''){
            $(this).closest(parentClass).find('img').attr({
              "src": selectVariant.data('image'),
              "data-srcset" : selectVariant.data('image'),
              "srcset" : selectVariant.data('image')
            });
          }
          $(this).closest(parentClass).attr('data-item',selectVariantId);
          $(this).closest(parentClass).find('.fbt-price').attr('data-fbtprice',selectVariant.data('price'));
          $(this).closest(parentClass).find('.fbt-price').html(newPrice);
          if (selectVariant.data('price-compare') !== undefined) {
            $(this).closest(parentClass).find('.fbt-price-compare').html(newPriceCompare).removeClass('hide');    
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at',selectVariant.data('price-compare'));
          } else {
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at','').addClass('hide');
          }
          updateTotal();
        });
        
        // checkChecked
        function checkItem(){
          $(checkBox).change(function() {
            if(this.checked) {
              $(this).closest(parentClass).attr('data-checked',true);
            }
            else{
              $(this).closest(parentClass).attr('data-checked',false);
            }
            updateTotal();
          });
        }
        function updateTotal(){
          let total = 0;
          let totalCompare = 0;
          $('.fbt-item-price').each(function() {
            let isChecked = $(this).closest('.fbt-item').find('.fbt-checkbox').is(':checked');
            let isPriceCompare = $(this).find('.fbt-price-compare').attr('data-price-at');
            if (isChecked){
              let value = parseFloat($(this).find('.fbt-price').attr('data-fbtprice'));
              
              total += value;
              if( isPriceCompare !== undefined && isPriceCompare !== '' ){
                let valueCompare = parseFloat(isPriceCompare);
                totalCompare += valueCompare - value;
              }
            }
          });
          //console.log(totalCompare); 
          $(totalPrice).html(theme.Currency.formatMoney(total, theme.moneyFormat));
            let totalSale  = totalCompare + total ;
            if( totalSale > total){
                $(totalPriceCompare).show();
                $(totalSave).show().html(`${$(totalSave).attr('data-txtsave')} <span class="text-theme">${theme.Currency.formatMoney(totalSale - total , theme.moneyFormat)}</span>` );
            }
            else{
              $(totalPriceCompare).hide();
              $(totalSave).hide().html();
            }
          $(totalPriceCompare).html(theme.Currency.formatMoney(totalCompare + total , theme.moneyFormat));
        }
        //click add product
        $('#fbt-button').click(function(e) {
          e.preventDefault();
          function addMultipleItemsToCart(productsToAdd) {
            var cartUrl = '/cart/add.js';
            var cartData = {
              items: productsToAdd
            };
          
            $.ajax({
              type: 'POST',
              url: cartUrl,
              data: cartData,
              dataType: 'json',
              beforeSend: function() {
               
                $('#fbt-button').addClass('is-loading');
              },
              success: function(data) {
                $('#fbt-button').removeClass('is-loading');
                theme.miniCart.refresh();
              },
              error: function(XMLHttpRequest, textStatus,err) {
                $('#fbt-button').removeClass('is-loading');
              }
            });
          }
          var productsToAdd = $(parentClass).map(function() {
            if($(this).attr('data-checked') === 'true' ){
              return {
                id: parseInt($(this).attr('data-item')),
                quantity: 1,
              };
            }
            
          }).get();
          addMultipleItemsToCart(productsToAdd);
        });
    }
  });
  return bundleProduct;
})()




// Upsell
theme.upsell = (function() {
  const upsellPopupSelector = '#jsUpsell';
  const $acceptButton = $('#jsUpsell .btn-upsell');
  const upsellProductId = $('#jsUpsell').data('id') || '';
  const acceptButtonClass = 'js-btn-accept';
  const delayTime = $('#jsUpsell').data('delay') || 3000;
  const isUpsellActive = $(upsellPopupSelector).length === 1;

  function showUpsellPopupWithDelay() {
    setTimeout(() => {
      $(upsellPopupSelector).modal('show');
    }, delayTime);
  }

  function handleAcceptButtonClick() {
    const isAcceptButton = $acceptButton.hasClass(acceptButtonClass);
    
    if (isAcceptButton) {
      Shopify.addItem(upsellProductId, 1, item => {
        theme.miniCart.refresh();
        const variantInfo = item.variant_title !== null ? `<i>(${item.variant_title})</i>` : '';
        const alertContent = `<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="${item.image}"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">${item.product_title} x ${item.quantity}</p>${variantInfo}<div><div>`;

        theme.alert.new(theme.strings.addToCartSuccess, alertContent, 3000, 'notice');
      });
    }
    
    $(upsellPopupSelector).modal('hide');
  }

  if (isUpsellActive) {
    $(document).ready(showUpsellPopupWithDelay);
    $acceptButton.on('click', handleAcceptButtonClick);
  }
})();




// Overwrite Shopify.onError in Shopify API
Shopify.onError = function(t, r) {
    var e;

    try {

      e = JSON.parse(t.responseText);

    } catch (err) {

      e = {};

    }
    var mess = e.message ? e.message + "(" + e.status + "): " + e.description : "Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + "."
    theme.alert.new('Alert',mess,3000,'warning');
}


// Fake-viewers
theme.fakeViewer = (function() {
  var $fakeViewClass = $('.js-fake-view'),
      minValue = $fakeViewClass.data('min'),
      maxValue = $fakeViewClass.data('max'),
      duration = $fakeViewClass.data('duration');

  function updateFakeViewCount() {
    var value = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    $fakeViewClass.text(value);
  }

  function initFakeViewCount() {
    updateFakeViewCount();

    if (minValue !== undefined && maxValue !== undefined && duration) {
      setInterval(updateFakeViewCount, duration);
    }
  }

  initFakeViewCount();
})();


// Product-suggest
theme.productSuggest = (function() {
  var $productNotification = $('.product-notification'),
      $closeButton = $('.close-notifi'),
      suggestionDuration = $productNotification.data('time') || 0,
      suggestionCookie = 'productSuggestClosed';

  function closeSuggestion() {
    $productNotification.remove();
    $.cookie(suggestionCookie, 'closed', { expires: 1, path: '/' });
  }

  function toggleSuggestion() {
    if ($productNotification.hasClass('active')) {
      $productNotification.removeClass('active');
    } else {
      var $productItems = $('.data-product'),
          randomIndex = Math.floor(Math.random() * $productItems.length),
          $selectedProduct = $($productItems[randomIndex]);

      $productNotification.addClass('active');
      var $productImage = $productNotification.find('.product-image img');
      $productImage.attr({
        'src': $selectedProduct.data('image'),
        'width': $selectedProduct.data('wimage'),
        'height': $selectedProduct.data('himage')
      });
      $productNotification.find('.product-image').attr({
        'href': $selectedProduct.data('url'),
        'title': $selectedProduct.data('title')
      });
      $productNotification.find('.product-name').text($selectedProduct.data('title')).attr('href', $selectedProduct.data('url'));
      $productNotification.find('.time-ago').text($selectedProduct.data('time'));
      $productNotification.find('.from-ago').text($selectedProduct.data('local'));
    }
  }

  function handleSuggestionInterval() {
    if (suggestionDuration !== 0) {
      setInterval(toggleSuggestion, suggestionDuration);
    }
  }

  function init() {
    if ($.cookie(suggestionCookie) === 'closed') {
      $productNotification.remove();
    } else {
      $closeButton.on('click', closeSuggestion);
      handleSuggestionInterval();
    }
  }

  init();
})();




theme.activeAccordion = (function(){
  $('.collapse').on('shown.bs.collapse', function () {
       $(this).prev().addClass('active-acc');
   });
   $('.collapse').on('hidden.bs.collapse', function () {
       $(this).prev().removeClass('active-acc');
   });
})()


// Anchor scroll
theme.anchorScroll = (function() {
  $(document).on('click', 'a[href^="#"]', function(event) {
    event.preventDefault();
    
    var $clickedLink = $(this);
    var disableAnchor = $clickedLink.hasClass('disabled-anchor');
    
    if (!disableAnchor) {
      var target = $clickedLink.attr('href');
      var targetOffsetTop = $(target).offset().top;
      
      $('html, body').animate({
        scrollTop: targetOffsetTop
      }, 500);
    }
  });
})();


// Product-recently-viewed
theme.productRecentlyViewed = (function() {
  var $recentViewedElement = $('.js-recently-view'),
      $viewButton = $('.js-recently-view-button'),
      $content = $('.js-recently-view-content'),
      currentProductHandle = $recentViewedElement.data('handle') || '',
      productLimit = $viewButton.data('limit') || 0,
      recentlyViewedArray = JSON.parse(localStorage.getItem('localRecentlyViewed')) || [],
      imageSize = $('#jsRecentlyViewed').attr("data-sizeimage");

  function processRecentlyViewed() {
    if (currentProductHandle) {
      var lastProductIndex = recentlyViewedArray.lastIndexOf(currentProductHandle);
      if (lastProductIndex !== -1) {
        recentlyViewedArray.splice(lastProductIndex, 1);
      }
      recentlyViewedArray.push(currentProductHandle);

      if (recentlyViewedArray.length > productLimit) {
        recentlyViewedArray.shift();
      }
      localStorage.setItem('localRecentlyViewed', JSON.stringify(recentlyViewedArray));
    }
  }

  function generateProductHtml(product) {
    var productPrice = product.price_varies ? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat);
    var productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '';
    var priceSaleClass = productComparePrice ? 'rc-sale' : 'rc-nosale';

    var productHtml = `
      <div class="col-6 col-lg-2 js-viewed-item mb-4">
        <div class="d-flex flex-column">
          <a class="w-100 recent-img ${imageSize}" href="${product.url}">
            <img class="lazyload" loading="lazy" data-src="${product.featured_image}&width=340"/>
          </a>
          <div class="text-center">
            <div class="mt-2"><a class="product-card__name" href="${product.url}">${product.title}</a></div>
            <span class="${priceSaleClass}">${productPrice}</span>
            <s class="small">${productComparePrice}</s>
          </div>
        </div>
      </div>`;

    return productHtml;
  }

  function updateViewButtonImage(product) {
    $viewButton.css('background-image', 'url(' + product.featured_image + ')').addClass('active');
  }

  processRecentlyViewed();

  if (recentlyViewedArray.length > 0) {
    // array of products
    recentlyViewedArray.forEach(function(productHandle) {
      Shopify.getProduct(productHandle, function(product) {
        var productHtml = generateProductHtml(product);
        $content.append(productHtml);
      });
    });

    // last product
    Shopify.getProduct(recentlyViewedArray[recentlyViewedArray.length - 1], function(product) {
      updateViewButtonImage(product);
    });
  }
})();

// Notice when soldout
theme.alert = (function(){
  function createAlert(title,mess,time,type,options){
    var aTitle = title || '',
        aTime = time || 2000,
        aMessage = mess || '',
        aClass = type || 'default',
        aOptions = options || {};
    $.growl($.extend({
      title: aTitle,
      message: aMessage,
      duration: aTime,
      style: aClass,
      size: 'large'
    }, aOptions));
  }

  function createCartAddedAlert(time){
    createAlert('Products have been added to cart','',time || 2500,'cart-added',{
      location: 'cart-added',
      delayOnHover: false
    });
  }

  return{
    new:createAlert,
    cartAdded:createCartAddedAlert
  }
})()

// Notice when soldout
theme.noticeSoldout = (function(){
  var $soldoutWrapFormClass = $('.js-contact-soldout'),
      $textClass = $('.js-notify-text'),
      $soldoutValueId = $('#ContactProduct');
  function noticeSoldout(variant){
    $soldoutWrapFormClass.find('.form-success').remove()
    if (variant.available){
      $textClass.find('span').text('');
      $soldoutWrapFormClass.addClass('hide');
    }else{
      $textClass.find('span').text(+ variant.name);
      $soldoutWrapFormClass.removeClass('hide');
      $soldoutValueId.val(variant.name).attr('value',variant.name);
    }
  }
  return {
    init : noticeSoldout
  }
})()

// Sticky cart
theme.stickyCart = (function() {
  var $anchor = $('#js-anchor-sticky-cart'),
      $stickyCartWrapper = $('.sticky-cart-wr');

  if ($anchor.length) {
    function handleStickyCart() {
      var anchorTop = $anchor.offset().top,
          anchorHeight = $anchor.outerHeight(),
          windowHeight = $(window).height(),
          windowScroll = $(window).scrollTop();

      $stickyCartWrapper.toggleClass('active', windowScroll > (anchorTop + anchorHeight - windowHeight));
    }

    $(window).on('scroll', handleStickyCart);
    handleStickyCart();
  }
})();

//Fix reload safari
window.addEventListener("pageshow", function(evt){
  if(evt.persisted){
  setTimeout(function(){
      window.location.reload();
  },10);
}
}, false);

// Back to top
theme.backToTop = (function(){
  $(document).ready(function(){"use strict";
  var progressPath = document.querySelector('.progress-wrap path');
  if ( progressPath != null ){
  var pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';    
  var updateProgress = function () {
    var scroll = $(window).scrollTop();
    var height = $(document).height() - $(window).height();
    var progress = pathLength - (scroll * pathLength / height);
    progressPath.style.strokeDashoffset = progress;
  }
  updateProgress();
  $(window).scroll(updateProgress); 
  var offset = 50;
  var duration = 550;
  jQuery(window).on('scroll', function() {
    if (jQuery(this).scrollTop() > offset) {
      jQuery('.progress-wrap').addClass('active-progress');
    } else {
      jQuery('.progress-wrap').removeClass('active-progress');
    }
  });       
  jQuery('.progress-wrap').on('click', function(event) {
    event.preventDefault();
    jQuery('html, body').animate({scrollTop: 0}, duration);
    return false;
  })
}

});
})()

theme.popOver = (function(){
  $('body').on('click', function (e) {
    $('[data-hotspot]').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).next().removeClass('active');
        }
        else{
          $(this).next().addClass('active');
        }
    });
});
  
})()


// Tooltip
theme.tooltip = (function(){
  var selector = '[data-toggle="tooltip"],[data-tooltip="true"]';
  function loadTooltip(){
    $(selector).tooltip(); //Bootstrap 4
  };
  $(document).on('click',selector,function(){
    $(this).tooltip('hide');
  });
  loadTooltip();
  return{
    load:loadTooltip
  }
})()

//Collections style 2
theme.Bgcollection = (function(){
    function Bgcollection(container){
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     var wrapper = this.wrapper = '.bgcollection-wrapper';
     var slider = this.slider = '#Bgcollection-' + sectionId;
     var $slider = $(slider, wrapper);
     $(".colgrid__bg--full[data-index='1']").addClass('active');
     $('.colgrid .colgrid__box').each(function(){
           var index = $(this).attr("data-index");
           $(this).hover(
           function() {
              $(".colgrid__bg--full[data-index='"+index+"']").addClass('active');
           }, 
           function() {
                 $(".colgrid__bg--full[data-index='"+index+"']").removeClass('active');
              }
           );
        });
      }
    return Bgcollection;
  })();


theme.hasInput = (function(){
  var inPut= $('.form-group .form-control');

  inPut.blur(function (){
    if(!this.value){
      $(this).removeClass('has-value');
    }else{
      $(this).addClass('has-value');
    }
  });

  var inpuSearch = $('#Search-In-Template');
  if (inpuSearch.length != 0 ) {
    if(inpuSearch.val().length != 0 ){
      inpuSearch.addClass('has-value');
    }
  }
  else{
    return;
  }
  
})()


$(theme.init);

class CountdownTimer extends HTMLElement {
  connectedCallback() {
    if (!this.countdownInitialized) {
      this.countdownInitialized = true; 

      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      const countDownDate = new Date(this.getAttribute('data-time')).getTime();
      const countdownContainer = document.createElement('div'); 

      this.appendChild(countdownContainer);

      function updateCountdown() {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / day);
        const hours = Math.floor((distance % day) / hour);
        const minutes = Math.floor((distance % hour) / minute);
        const seconds = Math.floor((distance % minute) / second);

        countdownContainer.innerHTML = `
        <ul class="list--inline or-countdown">
          <li>
          <span class="countdown-time">${days}</span><span class="countdown-text">Days</span> <span class="hide countdown-time-single">D</span>
          </li>
          <li>
          <span class="countdown-time">${hours}</span> <span class="countdown-text">Hours</span> <span class="hide countdown-time-single">H</span>
          </li>
          <li>
          <span class="countdown-time">${minutes}</span> <span class="countdown-text">Mins</span> <span class="hide countdown-time-single">M</span>
          </li>
          <li>
          <span class="countdown-time">${seconds}</span> <span class="countdown-text">Secs</span> <span class="hide countdown-time-single">S</span>
          </li>
          </ul>
        `;

        if (distance > 0) {
          requestAnimationFrame(updateCountdown);
        } else {
          countdownContainer.innerHTML = "Countdown Finished!";
        }
      }

      updateCountdown();
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);


class CheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('a[name="checkout"]');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('checkout-button', CheckoutButton);


$(document).ready(function() {
		$(".accordion-header").on("click", function() {
			$(".accordion-content").slideUp(), $(".accordion-header").removeClass("active").find(".accordion-icon").html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="#D2D2D2"/></svg>');
			const content = $(this).next(".accordion-content");
			content.is(":hidden") && (content.slideDown(), $(this).addClass("active").find(".accordion-icon").html(`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 11H19V13H5V11Z" fill="#D2D2D2"/>
              </svg>`))
		})
	}), $(".modal-toggles").on("click", function(e) {
		$(".bmodal").toggleClass("is-visible")
	}), $(document).ready(function() {
		count = 0, $(".show_hide_content").each(function() {
			count = count + 1, $(".show_hide_content").wrapInner('<div class="full_wrap seo_inner_content" id="content_inner_' + count + '"></div>'), $(".show_hide_content").append('<button href="javascript:void(0);" class="show_hide_anchor" data-id="content_inner_' + count + '">+ Show More</button>')
		}), $(document).on("click", ".show_hide_anchor", function() {
			if ($(this).toggleClass("active"), $(this).hasClass("active") ? $(this).text("- Show Less") : $(this).text("+ Show More"), $(this).parents(".show_hide_content").find(".seo_inner_content").toggleClass("active"), $(this).parents(".show_hide_content").find(".seo_inner_content").hasClass("active")) {
				id = $(this).attr("data-id");
				var content = document.getElementById(id),
					contentHeight = content.scrollHeight;
				content.style.maxHeight = contentHeight + "px"
			} else id = $(this).attr("data-id"), $("#" + id).removeAttr("style")
		})
	});


$(document).ready(function(){
  ysscount=0;
  $('.ys_custom_gallery_swiper').each(function(){
    ysscount++;
    this_item = $(this);
    this_item.addClass("swiper-container customswiper"+ysscount);
   // this_item.wrapInner('<div class="swiper-wrapper"></div>');
   // this_item.find("li").wrap('<div class="swiper-slide"></div>');
   // this_item.append('<div class="swiper-pagination"></div>');
   
    
    
    desk_item = this_item.attr("data-desktop_items");
    mob_item = this_item.attr("data-mobile_items");
    ipad_item = this_item.attr("data-ipad_items");
    ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    slider_mode = this_item.attr("data-mode");
    swiper_arrows = this_item.attr("data-swiper-style-arrow");
    swiper_style = this_item.attr("data-swiper_style");
    slider_autoplay = this_item.attr("data-slider-autoplay");
    slider_center = this_item.attr("data-slider-center");
    slider_effect = this_item.attr("data-slider-effect");
    slider_desktop_padding = this_item.attr("data-desktop-padding");
    slider_ipad_horizontal_padding = this_item.attr("data-ipad-horizontal-padding");
    slider_ipad_vertical_padding = this_item.attr("data-ipad-vertical-padding");
    slider_mobile_padding = this_item.attr("data-mobile-padding");
    desktop_offset = this_item.attr("data-desktop-offset");
    mobile_offset = this_item.attr("data-mobile-offset");
    ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    slider_loop = this_item.attr("data-slider-loop");
    
    swiper_navigation= {};
    swiper_pagination={};
    slider_autoplay_start={};
    var is_slider_loop = true;
    var is_slider_center = false;

    if(slider_loop == 'false'){
      is_slider_loop = false;
    }
    else{
      is_slider_loop = true;
    }
    
     if(slider_center == 'false'){
      is_slider_center = false;
    }
    else{
      is_slider_center = true;
    }

    if(swiper_arrows == 'true'){
       this_item.append('<div class="swiper-button-next swiper_arrows  customswiper_next'+ysscount+'"></div><div class="swiper-button-prev swiper_arrows  customswiper_prev'+ysscount+'"></div>');
      swiper_navigation= {
               nextEl: ".customswiper_next"+ysscount,
              prevEl: ".customswiper_prev"+ysscount,
          };
    }
    if(swiper_style == 'donts'){
      this_item.append('<div class="swiper-pagination"></div>');
      swpier_pagination ={
              el: ".swiper-pagination",
           type: "bullets",
           clickable: true,
          };
    }else if(swiper_style == 'progress_bar') {
        swpier_pagination =  {
              el: ".swiper-pagination",
           type: "progressbar",
           clickable: true,
          };
    }else{
      swpier_pagination = {};
    }
    if( slider_autoplay == 'true'){
       slider_autoplay_start = {
            delay: 3500,
            disableOnInteraction: false,
          };
    }else{
       slider_autoplay_start = {
           delay: 250000000000,
            disableOnInteraction: true,
          };
    }
    
    if(slider_mode == 'normal') {
      var partner_swiper = new Swiper('.customswiper'+ysscount, {
          spaceBetween: 0,
          navigation: swiper_navigation,
        effect: ((slider_effect == 'fade') ? "fade" : "") , 
         pagination:  {
              el: ".swiper-pagination",
           type: ((swiper_style == 'progress_bar') ? "progressbar" : "bullets"),
           clickable: true,
          },
          
          loop: is_slider_loop,
          autoplay: slider_autoplay_start,
            centeredSlides: is_slider_center,
          breakpoints: {
              0: {
                  slidesPerView: mob_item,
                  spaceBetween: slider_mobile_padding,
                  slidesOffsetBefore: mobile_offset
              },
              481: {
                  slidesPerView: ipad_item_vertical,
                  spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore:ipad_vertical_offset
              },
              786: {
                  slidesPerView: ipad_item_horizontal,
                  spaceBetween: slider_ipad_horizontal_padding,
                slidesOffsetBefore: ipad_horizontal_offset
              },
              1100: {
                  slidesPerView: desk_item,
                  spaceBetween: slider_desktop_padding,
                slidesOffsetBefore: desktop_offset
              }
          }
      });
    }else{
      this_item.find(".swiper-wrapper").addClass("swipanim");
      var partner_swiper = new Swiper('.customswiper'+ysscount, {
          spaceBetween: 0,
          navigation: swiper_navigation,
       effect: ((slider_effect == 'fade') ? "fade" : "") , 
          pagination:  {
              el: ".swiper-pagination",
           type: ((swiper_style == 'progress_bar') ? "progressbar" : "bullets"),
           clickable: true,
          },
          
          loop: is_slider_loop,
            freeMode: true,
            spaceBetween: 0,
            grabCursor: true,
            slidesPerView: 7,
            
            autoplay: {
              delay: 1,
              disableOnInteraction: true
            },
            freeMode: true,
            speed: 5000,
            freeModeMomentum: false,
          breakpoints: {
              0: {
                  slidesPerView: mob_item,
                  spaceBetween: slider_mobile_padding,
                slidesOffsetBefore: mobile_offset
              },
              481: {
                  slidesPerView: ipad_item_vertical,
                  spaceBetween: slider_ipad_vertical_padding,
                slidesOffsetBefore:ipad_vertical_offset
              },
              786: {
                  slidesPerView: ipad_item_horizontal,
                  spaceBetween: slider_ipad_horizontal_padding,
                  slidesOffsetBefore: ipad_horizontal_offset
              },
              1100: {
                  slidesPerView: desk_item,
                  spaceBetween: slider_desktop_padding,
                 slidesOffsetBefore: desktop_offset
              }
          }
      });
    }
  });
  
   $('.ys_custom_gallery_swiper_test').each(function(){
    ysscount++;
    this_item = $(this);
    this_item.addClass("swiper-container customswiper"+ysscount);
    this_item.wrapInner('<div class="swiper-wrapper"></div>');
    this_item.find("li").wrap('<div class="swiper-slide"></div>');
    this_item.append('<div class="swiper-button-next swiper_arrows2  customswiper_next'+ysscount+'"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev'+ysscount+'"></div>');

    desk_item = this_item.attr("data-desktop_items");
    mob_item = this_item.attr("data-mobile_items");

    var partner_swiper = new Swiper('.customswiper'+ysscount, {
          spaceBetween: 0,
          navigation: {
              nextEl: ".customswiper_next"+ysscount,
              prevEl: ".customswiper_prev"+ysscount,
          },
          loop: false,
          // autoplay: {
          //   delay: 3500,
          //   disableOnInteraction: false,
             
          // },
          breakpoints: {
              0: {
                  slidesPerView: mob_item,
                  spaceBetween: 20,
                 slidesOffsetBefore: 30
              },
              481: {
                  slidesPerView: desk_item,
                  spaceBetween: 30,
                 slidesOffsetBefore: 230
              },
              786: {
                  slidesPerView: desk_item,
                  spaceBetween: 30,
                 slidesOffsetBefore: 30
              },
              1100: {
                  slidesPerView: desk_item,
                  spaceBetween: 30,
                 slidesOffsetBefore: 30
              }
          }
      });
    
  });
});


$(window).scroll(function(){
	if($(window).scrollTop() > 0){
		//$('.gototop').fadeIn(200);
		$('body').addClass("scrolled");
	}else{
		//$('.gototop').fadeOut(200);
		$('body').removeClass("scrolled");
	}
});

/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */
(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState='animation-play-state',css3AnimationIsSupported=!1,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,!1)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+':'+obj[p])}}
tabjson.push();return'{'+tabjson.join(',')+'}'},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,'paused')}else{if($.fn.pause){$marqueeWrapper.pause()}}
$this.data('runningStatus','paused');$this.trigger('paused')},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,'running')}else{if($.fn.resume){$marqueeWrapper.resume()}}
$this.data('runningStatus','resumed');$this.trigger('resumed')},toggle:function(){methods[$this.data('runningStatus')=='resumed'?'pause':'resume']()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find('.js-marquee:first').html())}};if(typeof options==='string'){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find('.js-marquee-wrapper')}
if($this.data('css3AnimationIsSupported')===!0){css3AnimationIsSupported=!0}
methods[options]()}
return}
var dataAttributes={},attr;$.each(o,function(key,value){attr=$this.attr('data-'+key);if(typeof attr!=='undefined'){switch(attr){case 'true':attr=!0;break;case 'false':attr=!1;break}
o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1000}
verticalDir=o.direction=='up'||o.direction=='down';o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find('.js-marquee').css({'margin-right':o.gap,'float':'left'});if(o.duplicated){$el.clone(!0).appendTo($this)}
$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find('.js-marquee-wrapper');if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr('style');$this.height(containerHeight);$this.find('.js-marquee').css({'float':'none','margin-bottom':o.gap,'margin-right':0});if(o.duplicated)$this.find('.js-marquee:last').css({'margin-bottom':0});var elHeight=$this.find('.js-marquee:first').height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=((parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10))*o.duration;o.duration=(parseInt(elHeight,10)/parseInt(containerHeight,10))*o.duration}else{o.duration=((parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10))*o.duration}}else{elWidth=$this.find('.js-marquee:first').width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=((parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10))*o.duration;o.duration=(parseInt(elWidth,10)/parseInt(containerWidth,10))*o.duration}else{o.duration=((parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10))*o.duration}}
if(o.duplicated){o.duration=o.duration/2}
if(o.allowCss3Support){var
elm=document.body||document.createElement('div'),animationName='marqueeAnimation-'+Math.floor(Math.random()*10000000),domPrefixes='Webkit Moz O ms Khtml'.split(' '),animationString='animation',animationCss3Str='',keyframeString='';if(elm.style.animation!==undefined){keyframeString='@keyframes '+animationName+' ';css3AnimationIsSupported=!0}
if(css3AnimationIsSupported===!1){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+'AnimationName']!==undefined){var prefix='-'+domPrefixes[i].toLowerCase()+'-';animationString=prefix+animationString;playState=prefix+playState;keyframeString='@'+prefix+'keyframes '+animationName+' ';css3AnimationIsSupported=!0;break}}}
if(css3AnimationIsSupported){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s infinite '+o.css3easing;$this.data('css3AnimationIsSupported',!0)}}
var _rePositionVertically=function(){$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?containerHeight+'px':'-'+elHeight+'px')+')')},_rePositionHorizontally=function(){$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?containerWidth+'px':'-'+elWidth+'px')+')')};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css('transform','translateY(0)')}else{$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?containerHeight+'px':'-'+((elHeight*2)-o.gap)+'px')+')')}}else{if(o.startVisible){$marqueeWrapper.css('transform','translateX(0)')}else{$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?containerWidth+'px':'-'+((elWidth*2)-o.gap)+'px')+')')}}
if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}
var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction=='up'?o.duration+(containerHeight/((elHeight)/o.duration)):o.duration*2}else{o.duration=o.direction=='left'?o.duration+(containerWidth/((elWidth)/o.duration)):o.duration*2}
if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
loopCount++}
else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
loopCount++}}
if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css('transform','translateY('+(o.direction=='up'?0:'-'+elHeight+'px')+')')}
animationCss={'transform':'translateY('+(o.direction=='up'?'-'+elHeight+'px':0)+')'}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
animationCss={'transform':'translateY('+(o.direction=='up'?'-'+elHeight+'px':containerHeight+'px')+')'};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
_rePositionVertically()}}else{_rePositionVertically();animationCss={'transform':'translateY('+(o.direction=='up'?'-'+($marqueeWrapper.height())+'px':containerHeight+'px')+')'}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css('transform','translateX('+(o.direction=='left'?0:'-'+elWidth+'px')+')')}
animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':0)+')'}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+' '+o.duration/1000+'s '+o.delayBeforeStart/1000+'s '+o.css3easing}
animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':containerWidth+'px')+')'};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+'0';keyframeString=$.trim(keyframeString)+'0 ';animationCss3Str=animationName+' '+o.duration/1000+'s 0s infinite '+o.css3easing}
_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={'transform':'translateX('+(o.direction=='left'?'-'+elWidth+'px':containerWidth+'px')+')'}}}
$this.trigger('beforeStarting');if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+' { 100%  '+_objToString(animationCss)+'}',$styles=$marqueeWrapper.find('style');if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$('head').append('<style>'+keyframeCss+'</style>')}
_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger('finished')});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger('finished')})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger('finished');if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}
$this.data('runningStatus','resumed')};$this.on('pause',methods.pause);$this.on('resume',methods.resume);if(o.pauseOnHover){$this.on('mouseenter',methods.pause);$this.on('mouseleave',methods.resume)}
if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:!0,css3easing:'linear',easing:'linear',delayBeforeStart:1000,direction:'left',duplicated:!1,duration:5000,speed:0,gap:20,pauseOnCycle:!1,pauseOnHover:!1,startVisible:!1}})(jQuery);


$(document).ready(function(){
  $('.rotating_text').marquee({
            gap: 100,
            delayBeforeStart: 0,startVisible:true,
            direction: 'left',
            duplicated: true,
    speed: 15,
            pauseOnHover: true
        });;

  $('.rotating_text2').marquee({
            gap: 50,
            delayBeforeStart: 0,startVisible:true,
            direction: 'left',
            duplicated: true,
    speed: 50,
            pauseOnHover: true
        });;
});

// Featured product block (homepage) add-to-cart + buy-now handling
(function(){
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function initFeaturedProduct(root) {
    if (!root || root.dataset.fpInit === '1') return;

    var form = root.querySelector('form.product-form');
    if (!form) return;

    var productJsonEl = root.querySelector('[data-featured-product-json]');
    var productData = null;
    if (productJsonEl) {
      try {
        productData = JSON.parse(productJsonEl.textContent || productJsonEl.innerText || '{}');
      } catch (e) {
        productData = null;
      }
    }

    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('.ai-featured-product-option'));
    var selectEl = root.querySelector('[data-featured-variant-select]');
    var priceEl = root.querySelector('[data-featured-price]');
    var compareEl = root.querySelector('[data-featured-compare]');
    var discountEl = root.querySelector('[data-featured-discount]');
    var addBtn = root.querySelector('[data-featured-add-to-cart]');
    var buyBtn = root.querySelector('[data-featured-buy-now]');
    var qtyInput = root.querySelector('.ai-featured-product-qty');

    var strings = {
      addToCart: (window.theme && window.theme.strings && window.theme.strings.addToCart) ? window.theme.strings.addToCart : 'Add to cart',
      soldOut: (window.theme && window.theme.strings && window.theme.strings.soldOut) ? window.theme.strings.soldOut : 'Sold out',
      unavailable: (window.theme && window.theme.strings && window.theme.strings.unavailable) ? window.theme.strings.unavailable : 'Unavailable'
    };
    if (addBtn) {
      var customAddText = addBtn.getAttribute('data-add-to-cart-text');
      if (customAddText) strings.addToCart = customAddText;
    }

    var currentVariant = null;

    function updatePrice(variant) {
      if (!variant) return;
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compareValueEl = compareEl.querySelector('[data-featured-compare-value]');
          if (compareValueEl) {
            compareValueEl.innerHTML = formatMoney(variant.compare_at_price);
          } else {
            compareEl.innerHTML = formatMoney(variant.compare_at_price);
          }
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (discountEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          discountEl.textContent = 'Save ' + percent + '%';
          discountEl.style.display = '';
        } else {
          discountEl.style.display = 'none';
        }
      }
    }

    function getVariantFromSelect() {
      if (!selectEl) return null;
      var opt = selectEl.options[selectEl.selectedIndex];
      if (!opt) return null;
      return {
        id: opt.value,
        available: !opt.disabled
      };
    }

    function updateButtons(variant) {
      var resolved = variant || getVariantFromSelect();
      if (!resolved) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      var available = resolved.available;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.classList.toggle('btn--sold-out', !available);
        var label = addBtn.querySelector('span');
        if (label) label.textContent = available ? strings.addToCart : strings.soldOut;
      }
      if (buyBtn) buyBtn.disabled = !available;
    }

    function getSelectedOptions() {
      var values = [];
      optionInputs.forEach(function(input) {
        if (input.type === 'radio') {
          if (input.checked) {
            values.push({ index: input.getAttribute('data-index'), value: input.value });
          }
        } else {
          values.push({ index: input.getAttribute('data-index'), value: input.value });
        }
      });
      return values;
    }
    function updateOptionDisplays() {
      var selected = getSelectedOptions();
      if (!selected || !selected.length) return;
      selected.forEach(function(opt) {
        if (!opt || !opt.index) return;
        var idx = String(opt.index).replace('option', '');
        var num = parseInt(idx, 10);
        if (!num) return;
        var el = root.querySelector('.js-swatch-display--' + num);
        if (el) el.textContent = opt.value;
      });
    }

    function findVariantFromOptions() {
      if (!productData || !productData.variants) return null;
      var selected = getSelectedOptions();
      if (!selected.length) return null;
      return productData.variants.find(function(variant) {
        return selected.every(function(opt) {
          return String(variant[opt.index]) === String(opt.value);
        });
      }) || null;
    }

    function updateFromVariant(variant) {
      currentVariant = variant || getVariantFromSelect();
      updatePrice(variant);
      updateButtons(variant);
      if (selectEl && variant) {
        selectEl.value = variant.id;
      }
      updateOptionDisplays();
    }

    function onOptionChange(event) {
      var variant = null;
      var target = event && event.target ? event.target : null;
      var directId = target && target.dataset ? target.dataset.variantId : null;
      if (directId) {
        if (selectEl) {
          selectEl.value = directId;
        }
        if (productData && productData.variants) {
          variant = productData.variants.find(function(v){ return String(v.id) === String(directId); }) || null;
        }
      }
      if (!variant) {
        variant = findVariantFromOptions();
      }
      if (!variant && selectEl && productData && productData.variants) {
        variant = productData.variants.find(function(v){ return String(v.id) === String(selectEl.value); }) || null;
      }
      updateFromVariant(variant);
    }

    if (optionInputs.length) {
      optionInputs.forEach(function(input){
        input.addEventListener('change', onOptionChange);
      });
    }

    if (selectEl) {
      selectEl.addEventListener('change', function(){
        var variant = null;
        if (productData && productData.variants) {
          variant = productData.variants.find(function(v){ return String(v.id) === String(selectEl.value); }) || null;
        }
        updateFromVariant(variant);
      });
    }

    var initialVariant = null;
    if (productData && productData.variants) {
      if (selectEl) {
        initialVariant = productData.variants.find(function(v){ return String(v.id) === String(selectEl.value); }) || null;
      }
      if (!initialVariant) {
        initialVariant = productData.selected_or_first_available_variant || productData.variants[0];
      }
    }
    updateFromVariant(initialVariant);

    if (window.QtySelector && window.jQuery && qtyInput) {
      // eslint-disable-next-line no-new
      new QtySelector($(qtyInput));
    }

    // Do not init AjaxCart here; we handle submit manually to keep variant selection in sync.

    function getQuantity() {
      var input = root.querySelector('.js-qty__input') || qtyInput;
      if (!input) return 1;
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 1) return 1;
      return value;
    }

    function ajaxAddItem(variantId, quantity, onSuccess, onError) {
      if (window.Shopify && typeof Shopify.addItem === 'function') {
        Shopify.addItem(variantId, quantity, onSuccess);
        return;
      }
      if (window.jQuery) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: variantId, quantity: quantity },
          dataType: 'json',
          success: onSuccess,
          error: function(xhr){
            if (onError) {
              try { onError(JSON.parse(xhr.responseText)); } catch(e) { onError(null); }
            }
          }
        });
        return;
      }
      if (window.fetch) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(function(res){
          if (!res.ok) { return res.json().then(function(err){ throw err; }); }
          return res.json();
        })
        .then(onSuccess)
        .catch(onError || function(){});
      }
    }

    function resolveVariantId() {
      if (optionInputs.length) {
        for (var i = 0; i < optionInputs.length; i++) {
          var optInput = optionInputs[i];
          if (optInput.type === 'radio' && !optInput.checked) continue;
          var directId = optInput.dataset ? optInput.dataset.variantId : null;
          if (directId) {
            if (selectEl) selectEl.value = directId;
            currentVariant = {
              id: directId,
              available: !optInput.disabled
            };
            return directId;
          }
        }
      }
      if (optionInputs.length) {
        var optionVariant = findVariantFromOptions();
        if (optionVariant) {
          updateFromVariant(optionVariant);
        }
      }
      var variantId = currentVariant && currentVariant.id;
      if (!variantId && selectEl) variantId = selectEl.value;
      return variantId;
    }

    function addToCart(redirectToCheckout) {
      if (root.dataset.fpSubmitting === '1') return;
      root.dataset.fpSubmitting = '1';
      var variantId = resolveVariantId();
      if (!variantId) {
        root.dataset.fpSubmitting = '';
        return;
      }

      var quantity = getQuantity();
      if (addBtn) addBtn.classList.add('is-loading');
      if (buyBtn) buyBtn.classList.add('is-loading');

      function clearSubmitting() {
        root.dataset.fpSubmitting = '';
      }

      ajaxAddItem(variantId, quantity, function(item){
        if (window.theme && window.theme.miniCart) {
          window.theme.miniCart.refresh();
        }
        if (redirectToCheckout) {
          // If Shopflo is loaded, open the mini-cart instead so user can click Checkout (which Shopflo intercepts)
          if (window.shopflo || window.SHOPFLO || window.ShopFlo || document.querySelector('script[src*="shopflo"]')) {
            if (window.theme && window.theme.miniCart && typeof window.theme.miniCart.open === 'function') {
              window.theme.miniCart.open();
            } else {
              window.location.href = '/cart';
            }
          } else {
            window.location.href = '/checkout';
          }
        }
        clearSubmitting();
      }, function(err){
        if (window.theme && window.theme.alert && err && err.description) {
          window.theme.alert.new('', err.description, 3000, 'warning');
        }
        clearSubmitting();
      });

      setTimeout(function(){
        if (addBtn) addBtn.classList.remove('is-loading');
        if (buyBtn) buyBtn.classList.remove('is-loading');
        clearSubmitting();
      }, 400);
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      addToCart(false);
    });
    if (buyBtn) {
      buyBtn.addEventListener('click', function(e){
        e.preventDefault();
        addToCart(true);
      });
    }

    root.dataset.fpInit = '1';
  }

  function initAllFeaturedProducts() {
    var blocks = document.querySelectorAll('.ai-featured-product');
    if (!blocks.length) return;
    blocks.forEach(initFeaturedProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeaturedProducts);
  } else {
    initAllFeaturedProducts();
  }
  document.addEventListener('shopify:section:load', initAllFeaturedProducts);
})();
